/* Digit Exclusive — custom finder dropdowns (dx) */
(function(){
  if (window.__dxMounted) return; window.__dxMounted = 1;

  /* ── HOVER MUST NOT STEAL THE KEYBOARD CURSOR ───────────────────────────
     Chrome re-hit-tests after a scroll and fires mouseenter on whatever row
     slid under a STATIONARY pointer. Measured headful on
     /collections/california: 13 of 16 ArrowDown presses fired one, because
     moving the cursor scrolls the list under the parked pointer. Those enters
     called move() as if the user had hovered, so one keypress could paint the
     cursor twice and land two rows away — the reported "click down once at
     707 and it goes to 747, skipping 714".
     A hover only counts when the pointer's own coordinates change. Identical
     coordinates mean the page moved, not the mouse, and the keyboard keeps
     the cursor. Any real move (or a wheel scroll, which is deliberate mouse
     intent) hands it straight back. */
  window.__dxKbd = window.__dxKbd || 0;
  (function(){
    if (window.__dxPtrWired) return; window.__dxPtrWired = 1;
    var px = null, py = null;
    function real(e){
      if (!e || typeof e.clientX !== 'number') return;
      /* Sub-pixel tolerance: clientX/clientY are doubles and come back
         fractional on a Retina display, so demand a whole pixel of travel
         before calling it a move. No one expresses hover intent in half a
         pixel; a scroll reuses the pointer position verbatim. */
      if (px !== null && Math.abs(e.clientX - px) < 1 && Math.abs(e.clientY - py) < 1) return;
      px = e.clientX; py = e.clientY; window.__dxKbd = 0;
    }
    /* Every event that can precede a hover, because a real pointer move fires
       pointerover/mouseover/mouseenter BEFORE mousemove — gating on mousemove
       alone blocked genuine hovers. Coordinates are the whole test: measured
       headful, a scroll fires pointerover+mouseover+mouseenter at the IDENTICAL
       parked position (674,306 x8 presses) and no mousemove whatsoever, while a
       real move always changes them first. */
    ['mousemove', 'pointermove', 'mouseover', 'pointerover', 'mouseenter']
      .forEach(function (t) { document.addEventListener(t, real, true); });
    /* A wheel scroll under the pointer is deliberate mouse intent, so hand the
       cursor back even though the pointer itself never moved. */
    document.addEventListener('wheel', function(){ window.__dxKbd = 0; }, true);
  })();

  /* ── DESKTOP ONLY ─────────────────────────────────────────────────────────
     iOS and Android do not render a <select> in the page at all — they hand it
     to the OS, which shows its own picker. That picker is always positioned
     correctly, never jitters, never mis-registers a tap, scrolls with momentum
     and works with VoiceOver. Nothing re-implemented in a <div> beats it, and
     every mobile defect reported so far came from trying. So on any touch
     device this file mounts NOTHING: no DOM changes, no listeners, the native
     <select> is left completely untouched.
     What the custom panel actually buys is type-to-search across 344 area
     codes + cities + state abbreviations, which only matters where there is a
     keyboard and no OS picker to compete with — i.e. a real pointer.        */
  var DX_DESKTOP = false;
  try { DX_DESKTOP = matchMedia('(hover: hover) and (pointer: fine)').matches; } catch (e) { DX_DESKTOP = false; }
  window.__dxDesktop = DX_DESKTOP ? 1 : 0;
  if (!DX_DESKTOP) return;

  /* ── REMEMBER A CLICK THAT LANDED BEFORE WE MOUNTED ───────────────────────
     Safari does NOT focus a <select> when you click it (macOS focuses text
     fields only), so `document.activeElement === sel` is always false there.
     Adoption keyed off focus therefore worked in Chrome and silently dropped
     the click in Safari — measured 0/6 first-click opens in WebKit on both
     surfaces, against 6/6 in Chromium. That is the "first click does nothing,
     second gives a focus ring, third opens".
     Record the interaction itself instead; focus never enters into it. */
  /* ── PRELOAD ON HOVER ─────────────────────────────────────────────────
     Now that navigable rows are real <a href>, the browser can fetch the
     destination while the pointer rests on it. `<link rel=prefetch>` is useless
     on this store — collection HTML is served `no-cache, no-store`, so the
     prefetched copy is discarded — but Speculation Rules honour it (measured
     1030ms -> 93ms). `eagerness: moderate` = on hover, not eagerly, so we only
     spend bandwidth on something the buyer is actually pointing at.
     Ad safety: a prefetch that is never visited fires NO pixel events, and a
     visit still fires exactly one. Verified before shipping. */
  (function () {
    try {
      if (!HTMLScriptElement.supports || !HTMLScriptElement.supports('speculationrules')) return;
      if (document.getElementById('dx-speculate')) return;
      var sr = document.createElement('script');
      sr.id = 'dx-speculate';
      sr.type = 'speculationrules';
      sr.textContent = JSON.stringify({
        prefetch: [{
          source: 'document',
          /* An attribute selector, not `:not(...)`: document-rule
             `selector_matches` only accepts a restricted selector subset, and
             the :not() form silently matched everything — an in-place row was
             still prefetched (observed as area-code-213 Running -> Failure). */
          where: { selector_matches: '.dx-pop a[data-dx-pre]' },
          eagerness: 'moderate'
        }]
      });
      document.head.appendChild(sr);
    } catch (e) {}
  })();

  /* Explicit preload for the keyboard cursor. Speculation rules accept a
     `list` source, which is how we prefetch a specific url on demand. */
  var __dxPreT = 0;
  function dxPreload(href) {
    try {
      if (!href || !HTMLScriptElement.supports || !HTMLScriptElement.supports('speculationrules')) return;
      clearTimeout(__dxPreT);
      __dxPreT = setTimeout(function () {
        try {
          if (window.__dxPreLast === href) return;
          window.__dxPreLast = href;
          var old = document.getElementById('dx-speculate-key');
          if (old) old.remove();
          var sr = document.createElement('script');
          sr.id = 'dx-speculate-key';
          sr.type = 'speculationrules';
          sr.textContent = JSON.stringify({ prefetch: [{ source: 'list', urls: [href] }] });
          document.head.appendChild(sr);
        } catch (e) {}
      }, 280);
    } catch (e) {}
  }
  window.__dxPreloadFn = dxPreload;

  window.__dxPending = window.__dxPending || null;
  (function () {
    function remember(e) {
      var el = e.target;
      if (!el || !el.closest) return;
      var sel = el.closest('select.de-finder__select, select.de-filter__select');
      if (!sel) {
        var wrap = el.closest('.de-finder__wrap, .de-filter');
        sel = wrap && wrap.querySelector('select.de-finder__select, select.de-filter__select');
      }
      if (sel) window.__dxPending = { sel: sel, t: Date.now() };
    }
    ['mousedown', 'touchstart', 'click'].forEach(function (ev) {
      document.addEventListener(ev, remember, true);
    });
  })();

  function boot(){
    try {
(function DX() {
    document.querySelectorAll('.dx-wrap,.dx-legend,.dx-tag--native,.dx-pop,.dx-backdrop,.dx-toast').forEach(function (n) { n.remove(); });

    /* ── THE SINGLE POSITIONER ────────────────────────────────────────────────
       Exactly one function may write position to an open panel. Previously four
       did (place, fit, a per-frame clamp, and a visualViewport `lift`) — on
       desktop they agreed, on iOS the visual viewport moves continuously during
       scroll and while the keyboard animates, so they raced and the panel
       visibly jittered in every direction. Everything now funnels through here.
       Coordinates are visual-viewport based, because .dx-pop is position:fixed
       and iOS offsets the visual viewport from the layout viewport.          */
    var DX_HOVER = true;
    try { DX_HOVER = matchMedia('(hover: hover)').matches; } catch (e) {}

    window.__dxPos = function (pop, btn) {
      if (!pop || !btn) return;
      var vv = window.visualViewport;
      var vw = vv ? vv.width      : window.innerWidth;
      var vh = vv ? vv.height     : window.innerHeight;
      var vx = vv ? vv.offsetLeft : 0;
      var vy = vv ? vv.offsetTop  : 0;
      var M  = 8;
      var r  = btn.getBoundingClientRect();

      /* natural width is measured once per panel per viewport width — never on
         every keystroke, or the panel visibly resizes as you type. */
      var sig = pop.id + '|' + Math.round(vw) + '|' + (pop.__dxGen || 0);
      var rendered = pop.offsetParent !== null || pop.getClientRects().length > 0;
      if (rendered && pop.__dxSig !== sig) {
        var pw = pop.style.width, pmw = pop.style.maxWidth;
        /* The inner .dx-list is an overflow scroll container, so the panel's
           max-content width does not pick up the widest row (desktop Pattern
           measured 232 while its rows needed 314). Un-clip the list for the
           measurement, then put it straight back. */
        var lm = pop.querySelector('.dx-list'), lw = '', lo = '';
        if (lm) { lw = lm.style.width; lo = lm.style.overflow;
          lm.style.setProperty('width', 'max-content', 'important');
          lm.style.setProperty('overflow', 'visible', 'important'); }
        /* Un-clipping the LIST is not enough: every row is a flex line whose
           text column carries `overflow:hidden; text-overflow:ellipsis` and
           `flex:1 1 auto`, so it shrinks instead of reporting how much room it
           wants and max-content came back 13-26px short of the real row. The
           class un-clips the columns themselves for the one frame being
           measured (flex:none makes each column size to its own content), then
           it comes straight off. */
        pop.classList.add('dx-measuring');
        pop.style.setProperty('width', 'max-content', 'important');
        pop.style.setProperty('max-width', 'none', 'important');
        /* .dx-pop is overflow:hidden, so scrollWidth is capped at clientWidth and
           under-reports the real content width (Pattern measured 232 when it
           needed 314). Take the shrink-wrapped rect, which is the truth. */
        pop.__dxNat = Math.ceil(Math.max(pop.getBoundingClientRect().width, pop.scrollWidth)) + 2;
        pop.classList.remove('dx-measuring');
        pop.style.width = pw; pop.style.maxWidth = pmw;
        if (lm) { lm.style.width = lw; lm.style.overflow = lo; }
        pop.__dxSig = sig; pop.__dxGrew = 0;
      }
      /* The only real ceiling is the viewport. A fixed 480 cap was narrower
         than the widest row this data can produce (597px), so it re-introduced
         the clipping it was meant to bound. Content decides the width; the
         viewport decides the limit. */
      var maxW = vw - M * 2;
      /* GROW-ONLY while open. Exact-fitting each keystroke makes the panel
         breathe in and out under the reader's eyes; never re-fitting leaves it
         clipped. Growing and holding does neither: it opens at the natural
         width of the browse list (331px, proportionate to a 152px control) and
         widens only when a query genuinely needs more room, then stays put.
         Reset on close, so the next open starts proportionate again. */
      var w = Math.max(r.width, Math.min(maxW, Math.max(224, pop.__dxNat || 264, pop.__dxWmax || 0)));
      if (!rendered) w = Math.max(r.width, 224);
      if (w > maxW) w = maxW;
      pop.__dxWmax = w;

      /* align to the anchor's NEAR edge (Google Flights behaviour), then pull
         inside the viewport. */
      var stack = btn.closest('.de-heroX__finder-stack') || btn.closest('[data-de-filter-bar]');
      var mid = stack
        ? (stack.getBoundingClientRect().left + stack.getBoundingClientRect().width / 2)
        : (vx + vw / 2);
      var left = ((r.left + r.width / 2) > mid + 1) ? (r.right - w) : r.left;
      left = Math.max(vx + M, Math.min(left, vx + vw - w - M));

      /* content height without mutating styles: chrome = panel - list */
      var lst = pop.querySelector('.dx-list');
      var chromeH = lst
        ? (pop.getBoundingClientRect().height - lst.getBoundingClientRect().height)
        : 10;
      var need = (lst ? lst.scrollHeight : pop.scrollHeight) + Math.max(0, chromeH) + 2;
      if (need < 160) need = band;   // unmeasurable content must not collapse the panel

      var hdr = parseFloat(getComputedStyle(document.documentElement)
                  .getPropertyValue('--de-header-h')) || 0;
      var top0 = vy + M + hdr;
      var bot0 = vy + vh - M;
      var band = Math.max(140, bot0 - top0);

      var below = bot0 - r.bottom - 6;
      var above = (r.top - 6) - top0;
      var maxH  = Math.min(need, band);
      var USABLE = 220;
      /* Decide which side ONCE per opening and keep it. Re-deciding on every
         scroll frame makes the panel jump hundreds of px in a single frame —
         measured at 408px — which is precisely what reads as "glitching".
         While open we only follow the anchor and clamp into the band.
         When the control sits mid-screen (short landscape especially) neither
         side has usable room and clamping leaves a ~140px sliver; native
         pickers overlap the control instead, so 'over' does that.          */
      if (pop.__dxMode === undefined) {
        var d0 = (below >= maxH) ? true : (above >= maxH ? false : below >= above);
        var room0 = d0 ? below : above;
        pop.__dxMode = (room0 < Math.min(USABLE, need)) ? 'over' : (d0 ? 'down' : 'up');
      }
      var mode = pop.__dxMode, down = (mode !== 'up'), top;
      if (mode === 'over') {
        maxH = Math.min(need, band);
        top  = Math.max(top0, Math.min(bot0 - maxH, r.bottom + 6));
      } else if (mode === 'down') {
        if (below < maxH) maxH = Math.max(140, Math.min(maxH, Math.max(below, 140)));
        top = r.bottom + 6;
      } else {
        if (above < maxH) maxH = Math.max(140, Math.min(maxH, Math.max(above, 140)));
        top = r.top - 6 - maxH;
      }
      if (top + maxH > bot0) top = bot0 - maxH;   // clamp, one rule, no special cases
      if (top < top0)        top = top0;

      pop.dataset.flip = down ? 'down' : 'up';
      var S = function (k, val) { pop.style.setProperty(k, val, 'important'); };
      S('right', 'auto'); S('bottom', 'auto'); S('transform', 'none');
      /* position:ABSOLUTE, not fixed. The panel must stay glued to its control
         and travel with the page, so the browser moves it during scroll and no
         JS runs at all — that is what removes the jitter. (position:fixed made
         it stick to the screen and drift away from the control.)
         Placed by measuring the delta from where it currently sits, so this is
         independent of whatever the offset parent happens to be. */
      S('position', 'absolute');
      S('width', Math.round(w) + 'px'); S('min-width', '0'); S('max-width', 'none');
      /* ── THE OFF-SCREEN FIRST OPEN ────────────────────────────────────────
         The placement below works by delta: "move me by (want - where I am)",
         starting from whatever style.top/left already say. That is only valid
         once they are actually set. On the FIRST open they are empty, so curT
         reads 0 while getBoundingClientRect() reports the element's STATIC
         position — and this panel is appended to <body>, so its static position
         is below the entire page. Measured on /collections/texas at scrollY 0:
         button at top 487, panel placed at top -12704px. It opened ~12,700px
         off-screen, which looks exactly like "the click did nothing". The
         second click closed it, the third opened it correctly, because by then
         style.top existed and the delta was sound. That is the three clicks.
         Seed an explicit origin so the delta always has a known base. */
      if (!pop.style.top)  S('top', '0px');
      if (!pop.style.left) S('left', '0px');
      var cur  = pop.getBoundingClientRect();
      var curL = parseFloat(pop.style.left) || 0;
      var curT = parseFloat(pop.style.top)  || 0;
      S('left', Math.round(curL + (left - cur.left)) + 'px');
      S('top',  Math.round(curT + (top  - cur.top )) + 'px');
      S('max-height', Math.round(maxH) + 'px');

      /* Self-correct: if any label is still being clipped, the measurement was
         wrong — grow once (never past the viewport) rather than shipping
         "Ascending sequence (AB…". Runs at most once per panel per width. */
      if (!pop.__dxGrew) {
        pop.__dxGrew = 1;
        /* Intrinsic sizing under-reports here (desktop Pattern measured 232 while
           its rows needed 314), so stop predicting: let the browser paint, then
           measure what is ACTUALLY clipped and widen to match. Runs once per
           panel per viewport width, before the user can read the list. */
        requestAnimationFrame(function () {
          var clip = 0;
          var labels = pop.querySelectorAll('.dx-opt__txt, .dx-tiername, .dx-pat-name, .dx-pat-meta, .dx-opt__st');
          for (var i = 0; i < labels.length && i < 80; i++) {
            var over = labels[i].scrollWidth - labels[i].clientWidth;
            if (over > clip) clip = over;
          }
          if (clip <= 1) return;
          var cur = pop.getBoundingClientRect().width;
          var grown = Math.min(maxW, Math.ceil(cur) + clip + 6);
          if (grown <= cur) return;                 // already at the viewport cap
          pop.__dxNat = grown;
          pop.style.setProperty('width', grown + 'px', 'important');
          var lft = pop.getBoundingClientRect().left;
          if (lft + grown > vx + vw - M) lft = vx + vw - M - grown;
          if (lft < vx + M) lft = vx + M;
          pop.style.setProperty('left', Math.round(lft) + 'px', 'important');
        });
      }
    };
    ['dx-css'].forEach(function (id) { var e = document.getElementById(id); if (e) e.remove(); });
    var ABBR = {Alabama:'AL',Alaska:'AK',Arizona:'AZ',Arkansas:'AR',California:'CA',Colorado:'CO',Connecticut:'CT',Delaware:'DE','District of Columbia':'DC','Washington DC':'DC',Florida:'FL',Georgia:'GA',Hawaii:'HI',Idaho:'ID',Illinois:'IL',Indiana:'IN',Iowa:'IA',Kansas:'KS',Kentucky:'KY',Louisiana:'LA',Maine:'ME',Maryland:'MD',Massachusetts:'MA',Michigan:'MI',Minnesota:'MN',Mississippi:'MS',Missouri:'MO',Montana:'MT',Nebraska:'NE',Nevada:'NV','New Hampshire':'NH','New Jersey':'NJ','New Mexico':'NM','New York':'NY','North Carolina':'NC','North Dakota':'ND',Ohio:'OH',Oklahoma:'OK',Oregon:'OR',Pennsylvania:'PA','Rhode Island':'RI','South Carolina':'SC','South Dakota':'SD',Tennessee:'TN',Texas:'TX',Utah:'UT',Vermont:'VT',Virginia:'VA',Washington:'WA','West Virginia':'WV',Wisconsin:'WI',Wyoming:'WY'};
    var NICK = { 'Bay Area':['415','628','510','341','650','408','669','925'], 'Silicon Valley':['650','408','669'],
      'SoCal':['213','310','323','424','562','626','657','714','747','818','858','909','949'],
      'Twin Cities':['612','651','763','952'], 'DFW':['214','469','972','817','682'],
      'Chicagoland':['312','773','872','847','630','708'] };
    // tier colours are the THEME's own tokens; copy + prices verified live 2026-09-10
    var TIER = {
      base:      { c: '#2563eb', p: 'from $250',   h: '626-885-<b>5858</b>' },
      special:   { c: '#1a891e', p: 'from $500',   h: '626-<b>222</b>-8088' },
      exclusive: { c: '#a67c1a', p: 'from $1,000', h: '<b>626-626</b>-5858' },
      premium:   { c: '#6d28d9', p: 'from $8,250', h: '<b>626-626-2222</b>' }
    };
    var CAP = 150, SEARCH_MIN = 13;
    var CLONE = ['background','backgroundColor','backgroundImage','backgroundRepeat','backgroundPosition','backgroundSize',
      'border','borderRadius','boxShadow','color','fontFamily','fontSize','fontWeight','fontStyle','letterSpacing',
      'lineHeight','padding','textAlign','textTransform','transition','minHeight','height','boxSizing'];

    var css = document.createElement('style'); css.id = 'dx-css';
    css.textContent = [
      '.dx-wrap{position:relative}',
      '.dx-btn{cursor:pointer;-webkit-appearance:none;appearance:none;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:block}',
      
      '.dx-pop{position:fixed;z-index:2147483000;display:none;overflow:hidden;background:#fff;border:1px solid rgba(0,0,0,.08);border-radius:12px;box-shadow:0 12px 34px rgba(0,0,0,.18),0 2px 8px rgba(0,0,0,.08);padding:5px;max-width:430px}',
      '.dx-pop.is-open{display:flex;flex-direction:column}',
      '.dx-list{flex:1 1 auto;min-height:0;overflow-y:auto;overflow-x:hidden;overscroll-behavior:contain}',
      '.dx-search{position:sticky;top:-5px;margin:-5px -5px 4px;padding:6px;background:#fff;border-bottom:1px solid #f0f0f2;border-radius:12px 12px 0 0}',
      '.dx-searchwrap{position:relative}',
      '.dx-search input{width:100%;height:30px;padding:0 28px 0 9px;border:1px solid #d2d2d7;border-radius:8px;font:500 13px/1 -apple-system,system-ui,sans-serif;color:#1d1d1f;outline:none;-webkit-appearance:none;box-sizing:border-box}',
      '.dx-search input::placeholder{color:#a1a1a6}',
      '.dx-search input:focus{border-color:#0071e3;box-shadow:0 0 0 3px rgba(0,113,227,.14)}',
      '.dx-clear{position:absolute;right:9px;top:50%;transform:translateY(-50%);width:19px;height:19px;border:0;border-radius:50%;background:#d2d2d7;color:#fff;font:700 11px/1 -apple-system,system-ui,sans-serif;cursor:pointer;display:none;align-items:center;justify-content:center;padding:0}',
      '.dx-clear.is-on{display:flex}', '.dx-clear:hover{background:#86868b}',
      '.dx-grp{padding:8px 9px 3px;font:700 9.5px/1.3 -apple-system,system-ui,sans-serif;letter-spacing:.07em;text-transform:uppercase;color:#86868b}',
      '.dx-opt{display:flex;align-items:center;gap:7px;padding:6px 9px;border-radius:8px;font:500 13px/1.25 -apple-system,system-ui,sans-serif;color:#1d1d1f;cursor:pointer;white-space:nowrap}',
      '.dx-opt__tick{width:11px;flex:0 0 11px;font-size:11px;color:#0071e3}',
      '.dx-opt__txt{overflow:hidden;text-overflow:ellipsis}',
      '.dx-opt__st{margin-left:auto;padding-left:16px;color:#8e8e93;font-size:11.5px;font-weight:500}',
      '.dx-opt__ab{margin-left:auto;padding-left:16px;color:#a1a1a6;font-size:11px;font-weight:650;letter-spacing:.04em}',
      '.dx-opt.is-sel{font-weight:650}',
      '.dx-opt.is-cursor{background:#0071e3;color:#fff}',
      '.dx-opt.is-cursor .dx-opt__tick{color:#fff}',
      '.dx-opt.is-cursor .dx-opt__st,.dx-opt.is-cursor .dx-opt__ab{color:rgba(255,255,255,.85)}',
      '.dx-opt em{font-style:normal;font-weight:700;color:#1d1d1f;background:#ffe14d;border-radius:2px;padding:1px 0}',
      '.dx-opt.is-cursor em{background:#ffe14d;color:#1d1d1f}',
      '.dx-why{color:#8e8e93;font-size:11.5px;font-weight:500}',
      '.dx-opt.is-cursor .dx-why{color:rgba(255,255,255,.85)}',
      /* ---- tier rows: colour, one plain line, and what it starts at ---- */
      '.dx-opt--tier{align-items:baseline;gap:11px;padding:9px 11px}',
      '.dx-tiername{font-weight:750;flex:0 0 auto}',
      '.dx-tierpat{font:650 12.5px/1 ui-monospace,SFMono-Regular,Menlo,monospace;color:#c7c7cc;letter-spacing:.01em;white-space:nowrap}',
      '.dx-tierpat b{font-weight:800;color:var(--tc)}',
      '.dx-tierprice{margin-left:auto;font-size:11.5px;font-weight:650;color:#6e6e73;white-space:nowrap}',
      /* colour-coded rows keep a light hover so the tier colours stay readable */
      '.dx-opt--tier.is-cursor{background:#f2f2f5;color:#1d1d1f}',
      '.dx-divider{height:1px;background:#ececf0;margin:5px 9px}',
      '.dx-more{padding:9px 10px 5px;font:500 11.5px -apple-system,system-ui,sans-serif;color:#a1a1a6;text-align:center}',
      '.dx-none{padding:14px 11px;font:500 12.5px/1.5 -apple-system,system-ui,sans-serif;color:#6e6e73}',
      '.dx-none b{color:#1d1d1f}', '.dx-none span{display:block;margin-top:4px;color:#a1a1a6;font-size:11.5px}',
      '.dx-sr{position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap}',
      '.dx-pop{scrollbar-width:thin;scrollbar-color:#c7c7cc transparent}',
      '.dx-pop::-webkit-scrollbar{width:12px}',
      '.dx-pop::-webkit-scrollbar-track{background:transparent;margin:43px 0 5px}',
      '.dx-pop::-webkit-scrollbar-thumb{background:#c7c7cc;border:3px solid #fff;background-clip:padding-box;border-radius:99px;min-height:30px}',
      '.dx-pop::-webkit-scrollbar-thumb:hover{background:#a1a1a6;border:3px solid #fff;background-clip:padding-box}',
      '@media (max-width:640px), (max-height:560px){',
      '  .dx-pop{position:fixed !important;left:50% !important;right:auto !important;top:auto !important;bottom:8px !important;',
      '    transform:translateX(-50%) !important;width:calc(100% - 16px) !important;min-width:0 !important;',
      '    max-width:460px !important;max-height:min(62vh,420px) !important;border-radius:16px !important;padding:6px !important;',
      '    box-shadow:0 -6px 40px rgba(0,0,0,.22) !important}',
      '  .dx-opt{flex-wrap:wrap;min-height:44px;padding:9px 12px;font-size:15px;border-radius:10px;white-space:normal}',
      '  .dx-opt--tier{flex-wrap:nowrap}',
      '  .dx-opt__st{flex:0 0 100%;margin-left:0;padding-left:18px;font-size:12.5px;margin-top:1px}',
      '  .dx-opt__ab{margin-left:auto;flex:0 0 auto}',
      '  .dx-tierdesc{font-size:12.5px}', '  .dx-tierprice{font-size:12.5px}',
      '  .dx-grp{padding:12px 12px 5px;font-size:10.5px}',
      '  .dx-search{margin:-6px -6px 5px;padding:8px;border-radius:16px 16px 0 0}',
      '  .dx-search input{height:42px;font-size:16px;border-radius:10px}',
      '  .dx-pop::-webkit-scrollbar-track{margin:58px 0 5px}',
      '  .dx-backdrop{position:fixed;inset:0;background:rgba(0,0,0,.28);z-index:2147482999;opacity:0;pointer-events:none;transition:opacity .18s}',
      '  body:has(.dx-pop.is-open) .dx-backdrop{opacity:1;pointer-events:auto}',
      '}',
      '@media (min-width:641px){ .dx-backdrop{display:none} }',
      '@media (max-height:420px){ .dx-pop{max-height:calc(100vh - 16px) !important} .dx-opt{min-height:38px;padding:7px 12px;font-size:14px} }',
      '@media (pointer: coarse){ .dx-opt{min-height:44px;padding:9px 11px;font-size:14.5px} .dx-search input{height:40px;font-size:16px} .dx-clear{width:24px;height:24px} }'
    ].join('\n');
    document.head.appendChild(css);

    var bd = document.createElement('div'); bd.className = 'dx-backdrop'; document.body.appendChild(bd);
    function esc(t) { return String(t).replace(/[&<>]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;' }[c]; }); }
    function norm(t) { return (t || '').toLowerCase()
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/['’`]/g, '')
      .replace(/[^a-z0-9]+/g, ' ')
      .replace(/\s+/g, ' ').trim(); }
    function ws(h, n) { var i = h.indexOf(n); while (i > -1) { if (i === 0 || !/[a-z0-9]/.test(h.charAt(i - 1))) return true; i = h.indexOf(n, i + 1); } return false; }
    function prep(raw) {
      var q = norm(raw).replace(/\barea\s*code\b/g, ' ').replace(/\bcode\b/g, ' ').replace(/\s+/g, ' ').trim();
      if (!q) return '';
      if (/^[\d ]+$/.test(q)) { var d = q.replace(/\D/g, '');
        if (d.length >= 4 && d.charAt(0) === '1') d = d.slice(1);
        if (d.length > 3) d = d.slice(0, 3); return d; }
      return q; }
    function ed(a, b, max) {
      if (Math.abs(a.length - b.length) > max) return max + 1;
      var prev = [], cur = [], i, j;
      for (j = 0; j <= b.length; j++) prev[j] = j;
      for (i = 1; i <= a.length; i++) { cur[0] = i; var best = i;
        for (j = 1; j <= b.length; j++) { cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + (a.charAt(i - 1) === b.charAt(j - 1) ? 0 : 1)); if (cur[j] < best) best = cur[j]; }
        if (best > max) return max + 1; prev = cur.slice(); }
      return prev[b.length]; }

    var OPEN = null, uid = 0;
    window.dxApis = [];

    /* If anything throws while replacing a control, the native <select> must
       come back. Otherwise a mid-build failure leaves a hidden select behind a
       dead button and the finder is unusable — on a live store that is worse
       than not shipping the component at all. */
    function safeBuild(sel, opts) {
      /* ── THE DEAD FIRST CLICK ──────────────────────────────────────────────
         The page ships a real <select>; this file replaces it later. In between
         there is a window where a click lands on an element that is about to be
         destroyed, so it does nothing — the "first click does nothing, second
         gives a blue outline (the select taking focus), third opens it".

         Deferring the swap while the select was focused made it permanent:
         every further click re-focused the select, so the deferral never ended
         and the control stayed native forever. Measured: 4 clicks, all landing
         on <SELECT.de-finder__select>, panel never opened.

         So do not defer and do not discard the click — ADOPT it. Build now, and
         if the person was already interacting with the native control, carry
         that straight into the new one: focus it and open the panel. Their click
         produces an open dropdown, which is what they asked for. */
      var wasEngaged = false;
      try {
        wasEngaged = !!(sel && document.activeElement === sel);
        var pend = window.__dxPending;
        if (!wasEngaged && pend && pend.sel === sel && (Date.now() - pend.t) < 10000) wasEngaged = true;
        if (wasEngaged) window.__dxPending = null;
      } catch (e) {}
      var prevDisplay = sel ? sel.style.display : null;
      try {
        var api = build(sel, opts);
        if (api && wasEngaged) {
          try {
            api.btn.focus({ preventScroll: true });
            if (!api.isOpen()) api.open();
          } catch (e) {}
        }
        return api;
      }
      catch (e) {
        try {
          if (sel) {
            sel.style.display = prevDisplay || '';
            delete sel.dataset.dxDone;
            var w = sel.parentNode && sel.parentNode.querySelector('.dx-wrap');
            if (w) w.remove();
          }
        } catch (e2) {}
        if (window.console) console.warn('dx: build failed, native control restored', e);
        return null;
      }
    }
    function build(sel, opts) {
      if (!sel || sel.dataset.dxDone) return null;
      opts = opts || {};
      var lab = opts.label || 'Choose';
      // Take the host select's exact appearance. The finder select is transparent
      // and borderless — its parent draws the white box — so styling the button
      // myself drew a second box inside the first one.
      var hs = getComputedStyle(sel), skin = {};
      CLONE.forEach(function (k) { skin[k] = hs[k]; });
      sel.dataset.dxDone = '1';
      var id = 'dx' + (++uid);
      var wrap = document.createElement('div'); wrap.className = 'dx-wrap';
      wrap.style.flex = hs.flex && hs.flex !== '0 1 auto' ? hs.flex : '1 1 auto';
      wrap.style.width = '100%'; wrap.style.minWidth = '0';
      var btn = document.createElement('button'); btn.type = 'button'; btn.className = 'dx-btn';
      CLONE.forEach(function (k) { try { btn.style[k] = skin[k]; } catch (e) {} }); btn.style.width='100%'; btn.style.boxSizing='border-box';
      /* The chevron is cloned from the host <select>'s computed background. If the
         theme CSS has not applied yet (slow connection, cold cache) the clone is
         'none' and the control ships with no arrow. Put it back explicitly. */
      if (!btn.style.backgroundImage || btn.style.backgroundImage === 'none') {
        btn.style.backgroundImage = "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'%3E%3Cpath d='M1 1l4 4 4-4' fill='none' stroke='%231d1d1f' stroke-width='1.6' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E\")";
        btn.style.backgroundRepeat = 'no-repeat';
        btn.style.backgroundPosition = 'calc(100% - 12px) 50%';
        btn.style.backgroundSize = '10px auto';
      }
      btn.setAttribute('aria-expanded', 'false'); btn.setAttribute('aria-haspopup', 'listbox'); btn.setAttribute('aria-label', lab);
      wrap.appendChild(btn);
      sel.parentNode.insertBefore(wrap, sel);
      sel.style.display = 'none';
      var pop = document.createElement('div'); pop.className = 'dx-pop'; pop.id = id; pop.setAttribute('role', 'listbox');
      document.body.appendChild(pop); btn.setAttribute('aria-controls', id);
      var live = document.createElement('div'); live.className = 'dx-sr'; live.setAttribute('aria-live', 'polite'); wrap.appendChild(live);
      var rows = [], vals = [], cur = -1, isOpen = false, box = null, CACHE = null, clr = null;

      function aliasesFor(full, group) {
        var m = full.split(' — '), code = m.length > 1 ? m[0].trim() : '', city = m.length > 1 ? m.slice(1).join(' — ') : full, a = [];
        if (/\bLA\b/.test(city)) a.push('Los Angeles');
        if (/\bNYC\b/.test(city) || /\b(Manhattan|Brooklyn|Queens)\b/i.test(city)) a.push('New York City');
        if (/Outer Boroughs/i.test(city)) { a.push('Bronx'); a.push('Staten Island'); }
        if (/\bDC\b/.test(city)) a.push('District of Columbia');
        if (/\bSt\.? /i.test(city)) a.push(city.replace(/\bSt\.? /gi, 'Saint '));
        if (/\bFort /i.test(city)) a.push(city.replace(/\bFort /gi, 'Ft. '));
        if (/\bFt\.? /i.test(city)) a.push(city.replace(/\bFt\.? /gi, 'Fort '));
        if (/\bMt\.? /i.test(city)) a.push(city.replace(/\bMt\.? /gi, 'Mount '));
        if (/^\d{3}$/.test(code)) Object.keys(NICK).forEach(function (k) { if (NICK[k].indexOf(code) > -1) a.push(k); });
        var st = group || full; if (ABBR[st]) a.push(ABBR[st]);
        return a; }
      function model() {
        if (CACHE) return CACHE;
        var out = [], k = sel.children, i, j;
        /* ── NARROW TO BROWSE, SEARCH EVERYTHING ──────────────────────────
           A state scope hides the other states' <option>s, and this used to
           drop them from the model entirely — so on /collections/california,
           typing "212" answered "Nothing matches 212" even though 212 plainly
           exists. Keep every option and mark the out-of-scope ones instead:
           browsing still shows only the state's codes (that narrowing is the
           point of picking a state), while a typed query searches the whole
           catalogue and ranks the state's own codes first. A searched row
           already carries its state name, so an out-of-state hit reads as
           "212 — Manhattan  New York NY" and cannot be mistaken for a local
           one, and picking it goes to that code's collection. */
        function push(op, g, gHidden) {
          var l = op.textContent.replace(/\s*\(\d[\d,]*\)\s*$/, '').trim(), al = aliasesFor(l, g);
          var handle = (op.value || '').split('/').pop();
          out.push({ v: op.value, l: l, g: g, n: norm(l), gn: norm(g), al: al, aln: al.map(norm),
            stAbbr: ABBR[g] || '', ownAbbr: (!g && ABBR[l]) ? ABBR[l] : '', tier: (opts.tier && TIER[handle]) ? TIER[handle] : null,
            out: (op.hidden || gHidden) ? 1 : 0 }); }
        for (i = 0; i < k.length; i++) { if (k[i].tagName === 'OPTGROUP') { for (j = 0; j < k[i].children.length; j++) push(k[i].children[j], k[i].label, !!k[i].hidden); } else if (k[i].tagName === 'OPTION') push(k[i], '', false); }
        if (opts.nav) { out = out.filter(function (o) { return o.v; });
          var allIx = -1; out.forEach(function (o, ix) { if (/^all\b/i.test(o.l)) allIx = ix; });
          if (allIx > -1) { var a2 = out.splice(allIx, 1)[0]; a2.isAll = 1; out.unshift(a2); } }
        CACHE = out; return out; }
      function find(all, raw) {
        /* No query: the scope stands, so only what the state actually offers. */
        var n = prep(raw);
        if (!n) return { list: all.filter(function (o) { return !o.out; }), q: '' };
        var toks = n.split(' ').filter(Boolean), sc = [], i, j;
        for (i = 0; i < all.length; i++) {
          var it = all[i]; if (!it.v) continue; var s = -1, why = null;
          for (j = 0; j < it.aln.length; j++) { if (it.aln[j] === n) { s = 1; why = it.al[j]; break; } }
          if (it.n.indexOf(n) === 0) { s = 0; why = null; }
          else if (s < 0) {
            if (ws(it.n, n)) s = 2;
            else { for (j = 0; j < it.aln.length; j++) { var an = it.aln[j], t = -1;
                if (an.indexOf(n) === 0 || ws(an, n)) t = 3; else if (an.indexOf(n) > -1) t = 6;
                if (t > -1 && (s < 0 || t < s)) { s = t; why = it.al[j]; } }
              if (s < 0 && toks.length > 1) { var hay = it.n + ' ' + it.gn + ' ' + it.aln.join(' ');
                if (toks.every(function (tk) { return ws(hay, tk); })) s = 4; }
              if (s < 0 && it.n.indexOf(n) > -1) s = 5;
              if (s < 0 && it.gn && ws(it.gn, n)) s = 7;
              if (s < 0 && it.gn && it.gn.indexOf(n) > -1) s = 8; } }
          if (s > -1) sc.push({ it: it, s: s, i: i, why: why }); }
        var fuzzy = false;
        if (!sc.length && n.length >= 4) { fuzzy = true; var max = n.length >= 7 ? 2 : 1;
          for (i = 0; i < all.length; i++) { var t2 = all[i]; if (!t2.v) continue;
            var words = (t2.n + ' ' + t2.gn + ' ' + t2.aln.join(' ')).split(' '), hit = false;
            for (j = 0; j < words.length; j++) { if (words[j].length >= 3 && ed(words[j], n, max) <= max) { hit = true; break; } }
            if (hit) sc.push({ it: t2, s: 9, i: i, why: null }); } }
        /* The state's own codes first, then everything else that matched. */
        sc.sort(function (a, b) { return (a.it.out ? 1 : 0) - (b.it.out ? 1 : 0) || a.s - b.s || a.i - b.i; });
        return { list: sc.map(function (x) { x.it.__why = x.why; return x.it; }), q: n, fuzzy: fuzzy }; }
      function mark(t, n) {
        if (!n) return esc(t);
        var lo = String(t).toLowerCase(), o = '', at = 0, i = lo.indexOf(n);
        if (i < 0) return esc(t);
        while (i > -1) { o += esc(String(t).slice(at, i)) + '<em>' + esc(String(t).slice(i, i + n.length)) + '</em>'; at = i + n.length; i = lo.indexOf(n, at); }
        return o + esc(String(t).slice(at)); }

      function render(raw) {
        pop.innerHTML = ''; rows = []; vals = []; cur = -1;
        /* Searching REPLACES the row layout: browse mode groups by state and
           shows `code — city`, while a query flattens the list and gives every
           row two more columns (state name + abbreviation) plus a (why) hint.
           Measured on /collections/all-numbers: browse rows need 321px, but a
           searched row needs up to 597px ("saint" -> "636 — St. Charles / St.
           Louis Suburbs (Saint Charles…)"). The natural width was measured ONCE
           per panel per viewport, in browse mode, so every search clipped —
           51 of 150 rows at up to +124px. Bumping a generation counter makes
           the measurement re-run for the layout actually on screen. */
        pop.__dxGen = (pop.__dxGen || 0) + 1;
        var listEl = document.createElement('div'); listEl.className = 'dx-list'; listEl.setAttribute('role', 'presentation');
        var res = find(model(), raw), nd = res.q, browsing = !nd, list = res.list, lastG = null;
        if (model().length > SEARCH_MIN) {
          var sw = document.createElement('div'); sw.className = 'dx-search';
          var iw = document.createElement('div'); iw.className = 'dx-searchwrap';
          box = document.createElement('input'); box.type = 'text'; box.value = raw || '';
          box.setAttribute('aria-label', 'Search ' + lab.toLowerCase());
          box.setAttribute('autocapitalize', 'none'); box.setAttribute('autocorrect', 'off');
          box.setAttribute('autocomplete', 'off'); box.setAttribute('spellcheck', 'false');
          box.setAttribute('enterkeyhint', 'search');
          box.setAttribute('role', 'combobox'); box.setAttribute('aria-autocomplete', 'list');
          box.setAttribute('aria-expanded', 'true'); box.setAttribute('aria-controls', pop.id);
          box.placeholder = opts.placeholder || 'Type to search…';
          box.addEventListener('click', function (e) { e.stopPropagation(); });
          box.addEventListener('input', function () { var v = box.value; render(v); box.focus({ preventScroll: true }); box.setSelectionRange(v.length, v.length); });
          /* bound on the panel, not the box: once a row holds focus the box no
             longer receives keydown, and arrows would die. Capture phase so it
             runs before anything inside.

             ★ ONCE PER PANEL, NEVER PER RENDER. render() runs on open and on
             every keystroke, and `pop.innerHTML = ''` at the top of it destroys
             the panel's CHILDREN but not the listeners on `pop` itself — so
             re-registering here stacked a new handler on every render. Each one
             is a separate function object, so the browser keeps them all and
             one ArrowDown moved the cursor once per listener: two renders made
             a single press jump two rows (the reported "at 707, press down
             once, land on 747, skipping 714"), and it got worse the longer the
             panel was used (measured on the live build: 5 -> 7, then 5 -> 9,
             then 5 -> 10 after successive opens; 119 violations of "one press =
             one row" across a 34-round interaction fuzz). The flag lives on the
             element, so it survives every re-render and re-open. */
          if (!pop.__dxKeys) {
            pop.__dxKeys = 1;
            pop.addEventListener('keydown', function (e) {
              var printable = e.key && e.key.length === 1 && !e.metaKey && !e.ctrlKey && !e.altKey;
              if ((printable || e.key === 'Backspace') && box && document.activeElement !== box) {
                try { box.focus({ preventScroll: true }); } catch (err) {}
                return;                     // let the character land in the box
              }
              key(e);
            }, true);
          }
          clr = document.createElement('button'); clr.type = 'button'; clr.className = 'dx-clear' + (raw ? ' is-on' : '');
          clr.textContent = '✕'; clr.setAttribute('aria-label', 'Clear');
          clr.addEventListener('click', function (e) { e.stopPropagation(); render(''); if (box) box.focus({ preventScroll: true }); });
          iw.appendChild(box); iw.appendChild(clr); sw.appendChild(iw); pop.appendChild(sw);
        } else { box = null; }
        pop.appendChild(listEl);
        /* ── WHERE DOES THIS ROW ACTUALLY GO? ─────────────────────────────
           Only give a row an href when clicking it really navigates, or the
           status bar promises a page the click never visits and the preload is
           wasted. Measured behaviour:
             homepage finder      option value IS the url
             filter bar, state    "California" -> /collections/california, and
                                  "All States" -> /collections/all-numbers
             filter bar, area     from /collections/all-numbers -> area-code-205
                                  from /collections/texas       -> stays put
                                  (a state scope makes it filter in place)
           The state->url map is read from the links the page already carries
           (mega menu / footer): all 51 state options matched, so no slug
           guessing and no second copy of STATE_TO_HANDLE to drift. */
        function stateHrefMap() {
          if (window.__dxStateHref) return window.__dxStateHref;
          var m = {};
          try {
            document.querySelectorAll('a[href*="/collections/"]').forEach(function (a) {
              var t = (a.textContent || '').trim();
              if (t && t.length < 30 && !m[t.toLowerCase()]) m[t.toLowerCase()] = a.getAttribute('href');
            });
          } catch (e) {}
          window.__dxStateHref = m;
          return m;
        }
        function destFor(it) {
          try {
            if (opts.nav) return (typeof it.v === 'string' && /^(\/|https?:\/\/)/.test(it.v)) ? it.v : null;
            var which = sel.getAttribute('data-de-filter');
            if (which === 'state') {
              if (!it.v) return '/collections/all-numbers';
              return stateHrefMap()[String(it.l || it.v).trim().toLowerCase()] || null;
            }
            if (which === 'area' && !it.v) {
              /* ── "ANY AREA CODE" HAS TO GO SOMEWHERE ────────────────────────
                 It had no destination, so it fell through to an in-place clear:
                 from /collections/area-code-602 (reached via Arizona) that
                 landed on /collections/all-numbers carrying a stale "State:
                 Arizona" chip while the State control read "All states" — a
                 filter the page could not satisfy, so it showed "0+ matching
                 numbers" and an empty-state. Measured exactly that.
                 Clearing the code means "show me everything at the level I was
                 browsing": the state's own collection when a state is in play
                 (page scope on an area-code page counts — the buyer got here
                 through it), and the whole catalogue when none is. */
              try {
                var stSel0 = document.querySelector('[data-de-filter="state"]');
                var stVal0 = stSel0 && stSel0.value ? String(stSel0.value).trim().toLowerCase() : '';
                /* Only a state the buyer actually CHOSE sends them back to that
                   state. On an area-code page the State control also reads a
                   state it derived from the code, and treating that as a choice
                   would answer "all-numbers -> 602 -> any area code" with
                   Arizona, which is not where they came from. de-polish remembers
                   the explicit pick for the tab under `de_state_scope` (the same
                   key that decides whether the area list narrows), so use that. */
                var chosen = '';
                try { chosen = (sessionStorage.getItem('de_state_scope') || '').trim().toLowerCase(); } catch (e4) {}
                if (stVal0 && chosen && chosen === stVal0) {
                  var stHref0 = stateHrefMap()[stVal0];
                  if (stHref0) return stHref0;
                }
              } catch (e2) {}
              return '/collections/all-numbers';
            }
            if (which === 'area' && /^\d{3}$/.test(String(it.v))) {
              /* On an unscoped collection the pick navigates here. On a scoped one
                 (e.g. /collections/california) it filters in place instead — but
                 /collections/area-code-213 shows exactly the same numbers, so the
                 destination is still honest, and the row stays useful for the
                 status bar, cmd-click and "copy link address".
                 (`?area=213` on a scoped collection does NOT work — measured: the
                 select stayed empty and 279 numbers were still listed — so it must
                 not be used here.) Those rows are tagged dx-opt--inplace below so
                 they are excluded from preloading, since the click never navigates. */
              return '/collections/area-code-' + it.v;
            }
          } catch (e) {}
          return null;
        }
        function row(it) {
          /* ── REAL LINKS WHERE THERE IS A REAL DESTINATION ──────────────────
             The homepage finder's option values ARE urls ("/collections/alabama"),
             so each row should be an <a href>, not a <div>. As a <div> the
             browser has nothing to show in the status bar on hover, no
             cmd/middle-click to open in a new tab, no "copy link address", and
             nothing it can preload. The filter-bar selects carry plain values
             ("Alabama", "205", "price-asc") that filter the page in place, so
             those rows stay <div>s — there is no destination to link to. */
          var dest = destFor(it);
          var inPlace = false;
          try {
            if (!opts.nav && sel.getAttribute('data-de-filter') === 'area') {
              var stSel = document.querySelector('[data-de-filter="state"]');
              inPlace = !!(stSel && stSel.value);
            }
          } catch (e) {}
          var r = document.createElement(dest ? 'a' : 'div');
          if (dest) {
            r.setAttribute('href', dest);
            /* only rows whose click actually navigates are worth preloading */
            r.setAttribute('data-dx-pre', '1');   // every destination row now navigates
          }
          r.className = (inPlace ? 'dx-opt dx-opt--inplace' : 'dx-opt') + (it.tier ? ' dx-opt--tier' : '') + (it.v === sel.value ? ' is-sel' : '');
          r.setAttribute('role', 'option'); r.setAttribute('tabindex', '-1'); r.setAttribute('aria-selected', it.v === sel.value ? 'true' : 'false');
          r.id = pop.id + '-o' + rows.length;
          /* de-row-carries-its-value-2026-09-20 — the row states WHICH option it
             is, so nothing downstream has to count positions.

             The search page intercepts these clicks and used to map a row to a
             select option by the index in this id. That only holds while the
             panel shows every option: the moment the buyer types, the list is a
             filtered subset and index N is a different option entirely. Typing
             "725" left one row at index 0, which is "Any area code"; typing "7"
             put 725 at the index whose option was 323. */
          r.setAttribute('data-dx-val', it.v == null ? '' : String(it.v));
          if (it.tier) {
            var nm = document.createElement('span'); nm.className = 'dx-tiername'; nm.textContent = it.l; nm.style.color = it.tier.c;
            var pat = document.createElement('span'); pat.className = 'dx-tierpat'; pat.style.setProperty('--tc', it.tier.c); pat.innerHTML = it.tier.h; pat.setAttribute('aria-hidden','true');
            var pr = document.createElement('span'); pr.className = 'dx-tierprice'; pr.textContent = it.tier.p;
            r.appendChild(nm); r.appendChild(pat); r.appendChild(pr);
          } else {
            var tk = document.createElement('span'); tk.className = 'dx-opt__tick'; tk.setAttribute('aria-hidden', 'true');
            tk.textContent = it.v === sel.value ? '✓' : '';
            var t = document.createElement('span'); t.className = 'dx-opt__txt';
            var html = mark(it.l, nd), why = it.__why;
            var redundant = (!browsing && it.g && why === it.stAbbr) || (it.ownAbbr && why === it.ownAbbr);
            if (why && !redundant && it.n.indexOf(nd) < 0) html += ' <span class="dx-why">(' + mark(why, nd) + ')</span>';
            t.innerHTML = html;
            r.appendChild(tk); r.appendChild(t);
            if (it.ownAbbr) { var ab = document.createElement('span'); ab.className = 'dx-opt__ab'; ab.innerHTML = mark(it.ownAbbr, nd); r.appendChild(ab); }
            else if (!browsing && it.g) { var stx = document.createElement('span'); stx.className = 'dx-opt__st'; stx.textContent = it.g; r.appendChild(stx); }
          }
          r.addEventListener('mouseenter', function () {
            if (window.__dxKbd) return;   /* the list scrolled under a parked pointer */
            move(rows.indexOf(r));
          });
          r.addEventListener('click', function (e) {
            /* a modified click belongs to the browser: cmd/ctrl = new tab,
               shift = new window, alt = download. Never hijack those. */
            if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
            /* ── GO TO THE COLLECTION RATHER THAN FILTERING IN PLACE ──────────
               A row with a destination is a real page, so let the browser go
               there. Filtering in place only searches the numbers already
               loaded: picking an area code on a state page left the grid
               showing 0 results while more loaded (measured on
               /collections/california + area 209 -> area select said "209",
               visible cards 0). /collections/area-code-209 renders the real set
               server-side, and it KEEPS the state — that page derives it from
               the code, so the State control still reads "California" after the
               jump (measured). It is also the prefetched path, so it is the
               fast one. Rows without a destination still filter in place. */
            if (dest) {
              if (pop.__dxOpenedAt && Date.now() - pop.__dxOpenedAt < 250) { e.preventDefault(); return; }
              /* Already there: clearing the area code while standing on that
                 exact collection would otherwise reload the page for nothing. */
              try {
                var here = location.pathname.replace(/\/+$/, '');
                var there = dest.replace(/^https?:\/\/[^\/]+/, '').split('?')[0].replace(/\/+$/, '');
                if (here === there) { if (e.preventDefault) e.preventDefault(); close(); return; }
              } catch (e3) {}
              close(); return;
            }
            if (e.preventDefault) e.preventDefault();
            /* opened on press: ignore the release belonging to that press, or
               the row under the cursor would be picked instantly */
            if (pop.__dxOpenedAt && Date.now() - pop.__dxOpenedAt < 250) return;
            pick(it.v, it.l);
          });
          listEl.appendChild(r); rows.push(r); vals.push(it.v);
          if (it.isAll) { var dv = document.createElement('div'); dv.className = 'dx-divider'; listEl.appendChild(dv); } }
        if (res.fuzzy && list.length) { var f = document.createElement('div'); f.className = 'dx-grp'; f.textContent = 'Did you mean'; listEl.appendChild(f); }
        var limit = browsing ? list.length : Math.min(list.length, CAP);
        for (var i = 0; i < limit; i++) { var it = list[i];
          if (browsing && it.g && it.g !== lastG) { lastG = it.g; var h = document.createElement('div'); h.className = 'dx-grp';
            h.setAttribute('role', 'presentation'); h.textContent = it.g; listEl.appendChild(h); }
          row(it); }
        if (limit < list.length) { var mo = document.createElement('div'); mo.className = 'dx-more';
          mo.textContent = '+ ' + (list.length - limit) + ' more — keep typing to narrow'; listEl.appendChild(mo); }
        if (!rows.length) { var e = document.createElement('div'); e.className = 'dx-none';
          e.innerHTML = 'Nothing matches <b>' + esc(raw || '') + '</b>' + (opts.emptyHint ? '<span>' + opts.emptyHint + '</span>' : ''); listEl.appendChild(e); }
        if (clr) clr.classList.toggle('is-on', !!raw);
        live.textContent = rows.length ? rows.length + (rows.length === 1 ? ' result' : ' results') : 'No results';
        /* The panel is a fixed pixel width, so a new row layout has to be
           re-fitted or it keeps the width of the layout it replaced — which is
           exactly how searching ended up clipped. open() places the panel
           itself, so only re-renders while open need this. */
        if (isOpen) place();
      }
      function pick(v, lbl) { sel.value = v;
        sel.dispatchEvent(new Event('change', { bubbles: true })); close(); }
      function move(i, takeFocus) {
        if (takeFocus) window.__dxKbd = 1;   /* keys own the cursor until the mouse really moves */
        if (cur > -1 && rows[cur]) rows[cur].classList.remove('is-cursor'); cur = i;
        var host = box || btn;
        if (rows[cur]) { rows[cur].classList.add('is-cursor'); rowIntoList(rows[cur]);
          if (rows[cur].id) host.setAttribute('aria-activedescendant', rows[cur].id);
          /* Hover preloading is driven by the browser (speculation rules,
             eagerness:moderate) and a keyboard cursor never hovers, so arrow
             keys would get none of it. Preload what the cursor rests on —
             debounced, so holding ArrowDown through 52 states does not fetch
             52 pages. */
          if (!rows[cur].classList.contains('dx-opt--inplace'))
            dxPreload(rows[cur].getAttribute && rows[cur].getAttribute('href'));
          /* Give the row real DOM focus. A browser only shows a link's target in
             the status bar on hover or on focus, and aria-activedescendant is
             neither — so arrow keys showed nothing. Typing is redirected back to
             the search box below, so roving focus costs nothing. */
          /* Focus only for keyboard moves. Hover must never steal focus: it
             paints a focus ring around the row on top of the blue cursor pill,
             which is what the owner saw. */
          if (takeFocus && rows[cur].focus) { try { rows[cur].focus({ preventScroll: true }); } catch (e) { } } }
        else host.removeAttribute('aria-activedescendant'); }
      /* THE PAINTED ROW IS THE TRUTH. `cur` is a counter, but three other
         things write .is-cursor: hover, the type-ahead module's setCur(), and
         a re-render (which resets cur to -1 while a row may still be marked).
         Stepping from a stale counter is what made one press move two rows,
         and what made the cursor restart at the first row. Read what the user
         can actually see, then step from there. */
      function at() {
        var el = pop.querySelector('.dx-opt.is-cursor');
        var i = el ? rows.indexOf(el) : -1;
        if (i > -1) cur = i;
        return cur;
      }
      function key(e) {
        if (e.key === 'Escape') { e.preventDefault(); close(); btn.focus({ preventScroll: true }); return; }
        if (e.key === 'ArrowDown') { e.preventDefault(); move(Math.min(rows.length - 1, at() + 1), 1); return; }
        if (e.key === 'ArrowUp') { e.preventDefault(); move(Math.max(0, at() - 1), 1); return; }
        if (e.key === 'Home') { e.preventDefault(); move(0, 1); return; }
        if (e.key === 'End') { e.preventDefault(); move(rows.length - 1, 1); return; }
        if (e.key === 'PageDown') { e.preventDefault(); move(Math.min(rows.length - 1, (at() < 0 ? 0 : at()) + 8), 1); return; }
        if (e.key === 'PageUp') { e.preventDefault(); move(Math.max(0, (at() < 0 ? 0 : at()) - 8), 1); return; }
        if (e.key === 'Tab') { close(); return; }
        if (e.key === 'Enter') { e.preventDefault(); var i = at() > -1 ? at() : (rows.length ? 0 : -1); if (i > -1) rows[i].click(); } }
      function label() { var op = sel.options[sel.selectedIndex];
        var t = op ? op.textContent.replace(/\s*\(\d[\d,]*\)\s*$/, '').trim() : '';
        if (btn.textContent !== t) btn.textContent = t; }
      var vvQ = false, avQ = false;
      function vvSoon(){ if (vvQ) return; vvQ = true;        // viewport CHANGED: re-measure
        requestAnimationFrame(function(){ vvQ = false; if (isOpen) place(); }); }
      function vvScroll(){ if (avQ) return; avQ = true;      // viewport MOVED: only check the anchor
        requestAnimationFrame(function(){ avQ = false; if (isOpen) anchorCheck(); }); }
      /* scrollIntoView() scrolls EVERY scrollable ancestor, the page included,
         so highlighting a row yanked the whole page. Scroll the list only.  */
      function rowIntoList(row) {
        var lst = pop.querySelector('.dx-list');
        if (!lst || !row) return;
        var lr = lst.getBoundingClientRect(), rr = row.getBoundingClientRect();
        if (rr.top < lr.top) lst.scrollTop -= (lr.top - rr.top);
        else if (rr.bottom > lr.bottom) lst.scrollTop += (rr.bottom - lr.bottom);
      }
      var openedAt = 0;
      function anchorCheck() {
        // a scroll landing in the same beat as the click must not close what it opened
        if (Date.now() - openedAt < 450) return;
        var vv = window.visualViewport;
        var vy = vv ? vv.offsetTop : 0, vh = vv ? vv.height : window.innerHeight;
        var r = btn.getBoundingClientRect();
        // generous tolerance: iOS shifts the viewport constantly during scroll
        if (r.bottom < vy - 48 || r.top > vy + vh + 48) close(); }
      /* The panel is position:fixed, so once it is placed it STAYS PUT while the
         page scrolls underneath — exactly like a native picker. Re-running the
         positioner on every scroll frame is what made it jitter and visibly
         grow/shrink as the available room changed. We only re-measure when the
         viewport itself changes (rotation, keyboard), and close the panel if the
         control it belongs to scrolls away. */
      function onPageScroll(e){ var t = e && e.target; if (t && t.closest && t.closest('.dx-pop')) return; anchorCheck(); }
      function place() { window.__dxPos(pop, btn); anchorCheck(); }
      function open(seed) { if (OPEN && OPEN !== api) OPEN.close();
        label(); render(seed || ''); pop.classList.add('is-open'); openedAt = Date.now(); pop.__dxOpenedAt = openedAt; place(); btn.setAttribute('aria-expanded', 'true'); isOpen = true; OPEN = api;
        var s3 = pop.querySelector('.is-sel'); if (s3) { rowIntoList(s3); move(rows.indexOf(s3)); }
        /* focus() scrolls the focused element into view — on the 52-row state
           panel that yanked the page 189.5px on every open. preventScroll keeps
           the caret placement without moving the page. */
        if (box && DX_HOVER) { box.focus({ preventScroll: true }); box.setSelectionRange(box.value.length, box.value.length); }
        window.addEventListener('scroll', onPageScroll, true); window.addEventListener('resize', place);
        if (window.visualViewport) { visualViewport.addEventListener('resize', vvSoon); visualViewport.addEventListener('scroll', vvScroll); } }
      function close() { pop.__dxMode = undefined; pop.__dxWmax = 0; pop.__dxSig = '';
        pop.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); isOpen = false;
        if (OPEN === api) OPEN = null; label();
        window.removeEventListener('scroll', onPageScroll, true); window.removeEventListener('resize', place);
        if (window.visualViewport) { visualViewport.removeEventListener('resize', vvSoon); visualViewport.removeEventListener('scroll', vvScroll); } }
      var api = { open: open, close: close, isOpen: function () { return isOpen; }, pop: pop, btn: btn, sel: sel, label: label,
        type: function (q) { if (!box) render(''); if (box) { box.value = q; box.dispatchEvent(new Event('input', { bubbles: true })); } },
        rows: function () { return rows.slice(); }, vals: function () { return vals.slice(); },
        cursor: function () { return cur; }, place: place, render: render, bust: function () { CACHE = null; },
        keyTo: function (k) { key(new KeyboardEvent('keydown', { key: k })); } };
      /* ── THE MULTI-CLICK BUG ───────────────────────────────────────────────
         `<html>` on this store sets `scroll-behavior: smooth`. Pressing a button
         focuses it, and if it is anywhere near a viewport edge the browser scrolls
         it into view — which, being smooth, ANIMATES. The button then slides out
         from under the pointer between mousedown and mouseup, so no click event is
         produced on it and the panel never opens. The page visibly jumps, the user
         clicks again (now it is centred, nothing scrolls) and it works.
         Measured before this fix, button 10px from the top edge:
             opened=false, page scrolled -526px
         preventDefault() on mousedown suppresses the default focus-and-scroll;
         focusing explicitly with preventScroll keeps keyboard behaviour intact. */
      /* ── OPEN ON PRESS, LIKE A NATIVE <select> ──────────────────────────
         The Sort control in the filter bar is a plain <select>, and it opens on
         mousedown. This opened on `click` — an event the browser only produces
         when mousedown AND mouseup land on the SAME element. Anything that
         re-rendered between press and release swallowed the whole interaction:
         no click event was ever generated, nothing happened, and the next press
         (page now settled) worked. That is the dead click.

         Opening on pointerdown removes that dependency and makes this feel
         identical to the native control. preventDefault() on the press also
         suppresses the browser's focus-scroll, which is why the separate
         mousedown handler that used to do that is gone. */
      var swallowUntil = 0;
      btn.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        e.preventDefault();
        e.stopPropagation();
        swallowUntil = Date.now() + 700;
        try { btn.focus({ preventScroll: true }); } catch (err) { try { btn.focus(); } catch (e2) {} }
        if (isOpen) close(); else open();
      });
      /* Fallback for keyboard (Enter/Space fire click with no pointerdown) and
         for anything that does not deliver pointer events. Swallows the click
         that follows a press we already handled. */
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        if (Date.now() < swallowUntil) { swallowUntil = 0; return; }
        if (isOpen) close(); else open();
      });
      btn.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown' || e.key === 'Enter' || e.key === ' ') { e.preventDefault(); if (!isOpen) open(); return; }
        if (!isOpen && e.key.length === 1 && !e.metaKey && !e.ctrlKey && !e.altKey) { e.preventDefault(); open(e.key); } });
      document.addEventListener('click', function (e) {
        if (!isOpen || pop.contains(e.target) || wrap.contains(e.target)) return;
        /* ── THE CAPTION BELONGS TO A <label> THAT WRAPS THE CONTROL ─────────
           Every filter field is `<label class="de-filter">` holding both its
           caption span and the control, so clicking the caption counts as a
           label activation: the browser forwards it to the control, which
           re-opened the panel this very click had just closed — so clicking
           beside "AREA CODE" to dismiss the list looked like it did nothing,
           and only a click further away worked. Measured by sweeping the bar:
           of 145 points outside the panel, the ONLY two that failed to close
           were on `.de-filter__label`.
           Cancel the forwarding, but only for THIS field's own label: a click
           on a different field's caption must still switch to that dropdown,
           which is what it does today. */
        var lbl = e.target && e.target.closest ? e.target.closest('label') : null;
        if (lbl && lbl.contains(btn)) e.preventDefault();
        close();
      });
      document.addEventListener('focusin', function (e) { if (isOpen && !pop.contains(e.target) && !wrap.contains(e.target)) close(); });
      sel.addEventListener('change', label);
      new MutationObserver(function () { CACHE = null; label(); }).observe(sel, { childList: true, subtree: true, attributes: true, attributeFilter: ['selected', 'hidden'] });
      label(); window.dxApis.push(api); return api; }

    var PH_STATE = 'Type to find a state…', PH_AREA = 'Type to find a code or city…';
    var HINT_STATE = 'Try a state name or its two-letter code.', HINT_AREA = 'Try a 3-digit code, a city, or a state.';
    var bar = document.querySelector('[data-de-filter-bar], [data-de-search-filter-bar]');
    if (bar) {
      var st = bar.querySelector('[data-de-filter="state"]'), ar = bar.querySelector('[data-de-filter="area"]');
      if (st) safeBuild(st, { label: 'State', placeholder: PH_STATE, emptyHint: HINT_STATE });
      if (ar) safeBuild(ar, { label: 'Area code', placeholder: PH_AREA, emptyHint: HINT_AREA });
    }
    var finder = document.querySelector('.de-heroX__finder');
    if (finder) {
      finder.querySelectorAll('select.de-finder__select').forEach(function (s) {
        var lab = ((s.querySelector('option') || {}).textContent || s.id).trim();
        var isArea = /area/i.test(lab), isState = /state/i.test(lab), isTier = /tier/i.test(lab);
        safeBuild(s, { label: lab, tier: isTier, nav: 1,
          placeholder: isArea ? PH_AREA : (isState ? PH_STATE : ''),
          emptyHint: isArea ? HINT_AREA : (isState ? HINT_STATE : '') });
      });
    }
    ['de:filterschanged', 'de:applied'].forEach(function (n) {
      document.addEventListener(n, function () { setTimeout(function () { window.dxApis.forEach(function (a) { a.bust(); a.label(); }); }, 0); }, true); });
    bd.addEventListener('click', function () { window.dxApis.forEach(function (a) { if (a.isOpen()) a.close(); }); });
    return window.dxApis.length;
  })()
} catch(e){ if(window.console) console.warn('dx src', e); return; }
    try {
(function(){var st=document.getElementById('dxAll')||document.createElement('style');st.id='dxAll';st.textContent=".dx-pop{overflow-x:hidden !important;padding:4px !important}.dx-pop .dx-opt,.dx-pop .dx-opt__txt{font-family:-apple-system,\"system-ui\",\"SF Pro Text\",Inter,\"Helvetica Neue\",Helvetica,Arial,sans-serif !important;font-size:14.5px !important;font-weight:600 !important;letter-spacing:-0.012em !important}.dx-pop .dx-opt__txt{font-feature-settings:\"tnum\" !important}.dx-pop .dx-opt{padding-top:5px !important;padding-bottom:5px !important}.dx-pop .dx-divider{margin-top:3px !important;margin-bottom:3px !important}.dx-pop .dx-grp{color:#3a3a3c !important;font-size:11px !important;letter-spacing:.72px !important;font-weight:700 !important;display:flex !important;align-items:center !important;justify-content:space-between !important}.dx-pop .dx-grp .dx-abbr{font-weight:700;color:#4a4d52;letter-spacing:.72px}.dx-pop .dx-opt__st,.dx-pop .dx-opt__ab{color:#4a4d52 !important}#dx1 .dx-opt__ab{font-size:12.5px !important;font-weight:600 !important;letter-spacing:0 !important}#dx1 .dx-opt.is-cursor .dx-opt__ab{color:rgba(255,255,255,.92) !important}#dx2 .dx-opt__txt{min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}#dx2 .dx-opt__st{flex:none;white-space:nowrap;font-size:13px !important;font-weight:600 !important}#dx2 .dx-ab2{font-size:13px !important;font-weight:600 !important;color:#4a4d52 !important;margin-left:7px !important;letter-spacing:0 !important}#dx2 .dx-opt.is-cursor .dx-opt__st,#dx2 .dx-opt.is-cursor .dx-ab2{color:rgba(255,255,255,.92) !important}.dx-pop .dx-opt.is-cursor:not(.dx-opt--tier){background-image:linear-gradient(rgb(10, 132, 255), rgb(0, 113, 227) 60%, rgb(0, 100, 204)) !important;background-color:transparent !important}#dx3 .dx-code{font-weight:800}#dx5 .dx-tierpat{display:none !important}#dx5 .dx-opt--tier{display:flex !important;align-items:center !important;border:1.5px solid transparent !important;background-origin:border-box !important;background-clip:padding-box,border-box !important;background-image:var(--dx-fill),var(--dx-ramp) !important;background-color:transparent !important;padding:10.5px 7.5px 10.5px 3.5px !important;border-radius:10px !important;margin:0 0 2px !important;box-shadow:none !important;transition:background-image .12s ease,box-shadow .12s ease,transform .12s ease !important}#dx5 .dx-opt--tier.is-cursor,#dx5 .dx-opt--tier:hover{background-image:var(--dx-fill-hi),var(--dx-ramp-hi) !important;box-shadow:0 3px 8px rgba(16,24,40,.22) !important;transform:translateY(-1px) !important;border-width:2.5px !important;padding:9.5px 9.5px 9.5px 2.5px !important}#dx5 .dx-tiername{font-family:-apple-system,\"system-ui\",\"SF Pro Display\",Inter,\"Helvetica Neue\",Helvetica,Arial,sans-serif !important;font-weight:700 !important;font-size:15px !important;line-height:1.2 !important;letter-spacing:-0.012em !important;font-feature-settings:\"tnum\" !important}#dx5 .dx-tierprice{margin-left:auto !important;font-family:-apple-system,\"system-ui\",\"SF Pro Display\",Inter,\"Helvetica Neue\",Helvetica,Arial,sans-serif !important;font-weight:700 !important;font-size:12.5px !important;line-height:1.3 !important;color:#5f6773 !important;white-space:nowrap !important;letter-spacing:-0.012em !important;padding-left:10px !important}.dx-btn{overflow:hidden !important}@media (max-width:640px){#dx2 .dx-opt{display:grid !important;grid-template-columns:18px minmax(0,1fr) !important;align-items:center !important;row-gap:1px !important;padding-top:7px !important;padding-bottom:7px !important}#dx2 .dx-opt__tick{grid-row:1 / span 2 !important;align-self:center !important}#dx2 .dx-opt__txt{grid-column:2 !important;grid-row:1 !important}#dx2 .dx-opt__st{grid-column:2 !important;grid-row:2 !important;margin-left:0 !important;padding-left:0 !important;justify-self:start !important}}\n.dx-pop .dx-search{margin:-4px -4px 4px !important;border-radius:11px 11px 0 0 !important}\n\n/* macOS overlay scrollbars are painted over the rows and fatten on hover — hide and redraw */\n.dx-list{scrollbar-width:none !important}\n.dx-list::-webkit-scrollbar{width:0 !important;height:0 !important;display:none !important}\n.dx-sb{position:absolute !important;right:3px !important;width:6px !important;border-radius:99px !important;background:transparent !important;opacity:0 !important;transition:opacity .12s ease !important;z-index:3 !important}\n.dx-pop.is-scrollable .dx-sb{opacity:1 !important}\n.dx-sb__thumb{position:absolute !important;left:0 !important;top:0 !important;width:6px !important;border-radius:99px !important;background:#c7cad1 !important;cursor:default !important}\n.dx-sb__thumb.is-active{background:#a9adb6 !important}\n\n/* on touch there is no hover and a finger landing on the bar must still scroll the list */\n@media (pointer: coarse){ .dx-sb{pointer-events:none !important} }\n\n@media (prefers-reduced-motion: reduce){\n  .dx-pop,.dx-opt,.dx-sb,.dx-sb__thumb,#dx5 .dx-opt--tier{transition:none !important}\n  #dx5 .dx-opt--tier.is-cursor,#dx5 .dx-opt--tier:hover{transform:none !important}\n}\n\n/* two of six pattern labels were long enough to wrap, leaving 40px rows next to 53px ones */\n#dx3 .dx-pat-meta{margin-left:.35em}\n@media (max-width:640px),(max-height:560px){\n  #dx3 .dx-opt__txt{display:block !important;white-space:normal !important}\n  #dx3 .dx-pat-name{display:block !important}\n  #dx3 .dx-opt{min-height:45px !important}\n  #dx3 .dx-pat-meta{display:block !important;margin-left:0 !important;margin-top:1px !important;\n    font-size:12.5px !important;color:#5f6773 !important;letter-spacing:0 !important}\n}\n";document.head.appendChild(st);})();
if(!window.__dxPatch) window.__dxPatch=(function(){
  var busy=false;
  var ABBR={"ALABAMA":"AL","ALASKA":"AK","ARIZONA":"AZ","ARKANSAS":"AR","CALIFORNIA":"CA","COLORADO":"CO","CONNECTICUT":"CT","DELAWARE":"DE","FLORIDA":"FL","GEORGIA":"GA","HAWAII":"HI","IDAHO":"ID","ILLINOIS":"IL","INDIANA":"IN","IOWA":"IA","KANSAS":"KS","KENTUCKY":"KY","LOUISIANA":"LA","MAINE":"ME","MARYLAND":"MD","MASSACHUSETTS":"MA","MICHIGAN":"MI","MINNESOTA":"MN","MISSISSIPPI":"MS","MISSOURI":"MO","MONTANA":"MT","NEBRASKA":"NE","NEVADA":"NV","NEW HAMPSHIRE":"NH","NEW JERSEY":"NJ","NEW MEXICO":"NM","NEW YORK":"NY","NORTH CAROLINA":"NC","NORTH DAKOTA":"ND","OHIO":"OH","OKLAHOMA":"OK","OREGON":"OR","PENNSYLVANIA":"PA","RHODE ISLAND":"RI","SOUTH CAROLINA":"SC","SOUTH DAKOTA":"SD","TENNESSEE":"TN","TEXAS":"TX","UTAH":"UT","VERMONT":"VT","VIRGINIA":"VA","WASHINGTON":"WA","WEST VIRGINIA":"WV","WISCONSIN":"WI","WYOMING":"WY","DISTRICT OF COLUMBIA":"DC"};
  var PAT={ascendingsequence:['ABCD','1234'],pairsaabb:['AABB','1122'],alternatingabab:['ABAB','1212'],alternatingabba:['ABBA','1221'],triplealternating:['ABABAB','121212']};
  var M={
    base:{fill:'linear-gradient(180deg,#fbfcff,#eef2fe)',fillHi:'linear-gradient(180deg,#f2f7ff,#dfe9fd)',ramp:'linear-gradient(180deg,#84c0ff,#1486ff)',rampHi:'linear-gradient(180deg,#5aaaff,#0b72e0)',text:'#1486ff'},
    special:{fill:'linear-gradient(180deg,#f8fbf8,#e8f3e9)',fillHi:'linear-gradient(180deg,#eef7ef,#d8ecda)',ramp:'linear-gradient(180deg,#3ada3f,#1a891e)',rampHi:'linear-gradient(180deg,#2ec434,#147018)',text:'#1a891e'},
    exclusive:{fill:'linear-gradient(180deg,#fffcec,#fdf0c2)',fillHi:'linear-gradient(180deg,#fff8dc,#fbe8a8)',ramp:'linear-gradient(180deg,#e8c34a,#a67c1a)',rampHi:'linear-gradient(180deg,#dcb433,#8c6714)',text:'#a67c1a'},
    premium:{fill:'linear-gradient(180deg,#fbf9fe,#f0e9fb)',fillHi:'linear-gradient(180deg,#f5f0fd,#e5daf8)',ramp:'linear-gradient(180deg,#ae87ea,#6d28d9)',rampHi:'linear-gradient(180deg,#9a6ee2,#5b1fb8)',text:'#6d28d9'}};
  var PRICES={base:'$250',special:'$500',exclusive:'$1,000',premium:'$8,250'};
  function canon(s){ return s.toLowerCase().replace(/[^a-z]/g,''); }
  return function patch(){
    if(busy) return; busy=true;
    var grew=0;
    try{
    document.querySelectorAll('.dx-pop').forEach(function(pop){
      pop.querySelectorAll('.dx-opt').forEach(function(r){
        var t=r.querySelector('.dx-opt__txt');
        if(t){
          var s=t.textContent.trim();
          var m=s.match(/^All ([a-z])(.*)$/);
          if(m){ var w='All '+m[1].toUpperCase()+m[2]; if(t.textContent!==w) t.textContent=w; }
          else if(pop.id==='dx3'){
            var f=PAT[canon(s)];
            if(f){ var nm=s.replace(/\s*\(.*$/,'').trim();
              var want='<span class="dx-pat-name">'+nm+'</span><span class="dx-pat-meta">(<span class="dx-code">'+f[0]+'</span> — '+f[1]+')</span>';
              if(t.innerHTML!==want) t.innerHTML=want; }
          }
        }
        if(pop.id==='dx2'){
          var stEl=r.querySelector('.dx-opt__st');
          if(stEl && !stEl.querySelector('.dx-ab2')){
            var nm2=(stEl.firstChild&&stEl.firstChild.nodeType===3?stEl.firstChild.textContent:stEl.textContent).trim();
            var ab=ABBR[nm2.toUpperCase()];
            if(ab){ var e=document.createElement('span'); e.className='dx-ab2'; e.textContent=ab; stEl.appendChild(e); grew=1; }
          }
        }
        if(pop.id==='dx5' && r.classList.contains('dx-opt--tier')){
          var nEl=r.querySelector('.dx-tiername'); if(!nEl) return;
          var key=nEl.textContent.trim().toLowerCase(); if(!M[key]) return;
          var tick=r.querySelector('.dx-opt__tick');
          if(!tick){ tick=document.createElement('span'); tick.className='dx-opt__tick';
                     tick.setAttribute('aria-hidden','true'); r.insertBefore(tick,r.firstChild); }
          var wt=r.getAttribute('aria-selected')==='true'?'✓':'';
          if(tick.textContent!==wt) tick.textContent=wt;
          r.style.setProperty('--dx-fill',M[key].fill);
          r.style.setProperty('--dx-fill-hi',M[key].fillHi);
          r.style.setProperty('--dx-ramp',M[key].ramp);
          r.style.setProperty('--dx-ramp-hi',M[key].rampHi);
          nEl.style.setProperty('color',M[key].text,'important');
          var pr2=r.querySelector('.dx-tierprice'), w2='from '+PRICES[key];
          if(pr2 && pr2.textContent!==w2) pr2.textContent=w2;
          var pt=r.querySelector('.dx-tierpat'); if(pt) pt.remove();
        }
      });
      if(pop.id==='dx2'){
        pop.querySelectorAll('.dx-grp').forEach(function(g){
          if(g.querySelector('.dx-abbr')) return;
          var ab=ABBR[g.textContent.trim().toUpperCase()]; if(!ab) return;
          var e=document.createElement('span'); e.className='dx-abbr'; e.textContent=ab; g.appendChild(e); });
      }
    });
    } finally { busy=false; }
    /* ★ THE PANEL IS MEASURED BEFORE THIS RUNS. render() sizes the panel to its
       rows, then a MutationObserver calls this, which APPENDS the state
       abbreviation column to every searched row in #dx2 — so the rows end up
       13-26px wider than the panel that was measured for them, and the city
       names clip. Re-measure once the rows are finally complete. Bounded to one
       refit per render generation, so this can never ping-pong with the
       observer that called it. */
    if (grew) {
      var op = document.querySelector('.dx-pop.is-open');
      if (op && op.__dxRefit !== op.__dxGen) {
        op.__dxRefit = op.__dxGen;
        var tb = document.querySelector('.dx-btn[aria-controls="' + op.id + '"]');
        if (tb) { op.__dxSig = ''; try { window.__dxPos(op, tb); } catch (err) {} }
      }
    }
  };
})();
window.__dxReveal=function reveal(pop){
  var sc=pop.querySelector('.dx-list')||pop;
  var cur=pop.querySelector('.dx-opt.is-cursor'); if(!cur) return;
  var opts=pop.querySelectorAll('.dx-opt');
  if(opts.length && opts[0]===cur){ sc.scrollTop=0; return; }
  if(opts.length && opts[opts.length-1]===cur){ sc.scrollTop=sc.scrollHeight; return; }
  var pr=sc.getBoundingClientRect(), ceiling=pr.top;
  var top=cur, prev=cur.previousElementSibling;
  if(prev && /dx-grp/.test(prev.className||'')) top=prev;
  var gutter=cur.getBoundingClientRect().height+4;
  var tr=top.getBoundingClientRect(), cr=cur.getBoundingClientRect();
  if(tr.top < ceiling+gutter) sc.scrollTop -= (ceiling+gutter-tr.top);
  else if(cr.bottom > pr.bottom-gutter) sc.scrollTop += (cr.bottom-(pr.bottom-gutter));
};
(function(){
  if (window.__dxBar) return; window.__dxBar = 1;
  var drag = null;

  function sync(pop){
    var list = pop.querySelector('.dx-list'), sb = pop.querySelector('.dx-sb');
    if(!list || !sb) return;
    var th = sb.firstChild;
    var span = list.scrollHeight - list.clientHeight;
    var can = span > 1;
    pop.classList.toggle('is-scrollable', can);
    if(!can) return;
    var trackTop = list.offsetTop, trackH = list.clientHeight;
    sb.style.top = trackTop + 'px';
    sb.style.height = trackH + 'px';
    var thumbH = Math.max(30, Math.round(trackH * (list.clientHeight / list.scrollHeight)));
    if (thumbH > trackH) thumbH = trackH;
    var range = trackH - thumbH;
    var prog = span > 0 ? (list.scrollTop / span) : 0;
    if (prog < 0) prog = 0; if (prog > 1) prog = 1;
    th.style.height = thumbH + 'px';
    th.style.transform = 'translateY(' + Math.round(prog * range) + 'px)';
  }

  function mount(pop){
    var list = pop.querySelector('.dx-list'); if(!list) return;
    var sb = pop.querySelector('.dx-sb');
    if(!sb){
      sb = document.createElement('div'); sb.className = 'dx-sb';
      sb.setAttribute('aria-hidden','true');
      var th = document.createElement('div'); th.className = 'dx-sb__thumb';
      sb.appendChild(th);
      pop.appendChild(sb);
    }
    if(!list.__dxScroll){
      list.__dxScroll = 1;
      list.addEventListener('scroll', function(){ sync(pop); }, {passive:true});
    }
    sync(pop);
  }

  // one global drag manager — the panel is rebuilt on every keystroke, so per-element listeners would pile up
  document.addEventListener('mousedown', function(e){
    var th = e.target && e.target.closest && e.target.closest('.dx-sb__thumb');
    if (th){
      var pop = th.closest('.dx-pop'); var list = pop && pop.querySelector('.dx-list');
      if(!list) return;
      e.preventDefault(); e.stopPropagation();
      drag = { list:list, pop:pop, thumb:th, y:e.clientY, top:list.scrollTop };
      th.classList.add('is-active');
      document.body.style.userSelect = 'none';
      return;
    }
    var track = e.target && e.target.closest && e.target.closest('.dx-sb');
    if (track){
      var pop2 = track.closest('.dx-pop'), list2 = pop2 && pop2.querySelector('.dx-list');
      var thumb2 = track.querySelector('.dx-sb__thumb');
      if(!list2 || !thumb2) return;
      e.preventDefault(); e.stopPropagation();
      var dir = e.clientY < thumb2.getBoundingClientRect().top ? -1 : 1;
      list2.scrollTop += dir * list2.clientHeight * 0.9;
    }
  }, true);

  document.addEventListener('mousemove', function(e){
    if(!drag) return;
    var list = drag.list, sb = drag.pop.querySelector('.dx-sb');
    if(!sb) return;
    var trackH = sb.clientHeight, thumbH = drag.thumb.offsetHeight;
    var range = trackH - thumbH; if (range <= 0) return;
    var span = list.scrollHeight - list.clientHeight;
    list.scrollTop = drag.top + (e.clientY - drag.y) * (span / range);
  }, true);

  document.addEventListener('mouseup', function(){
    if(!drag) return;
    drag.thumb.classList.remove('is-active');
    document.body.style.userSelect = '';
    drag = null;
  }, true);

  window.addEventListener('resize', function(){
    document.querySelectorAll('.dx-pop.is-open').forEach(function(p){ sync(p); });
  });

  // run after every render, on the back of the existing patcher
  var inner = window.__dxPatch;
  window.__dxPatch = function(){
    inner();
    try { document.querySelectorAll('.dx-pop').forEach(mount); } catch(err){}
  };
  window.__dxBarSync = sync;
})();
(function(){
  if (window.__dxA11y) return; window.__dxA11y = 1;
  var live = document.getElementById('dx-live');
  if(!live){
    live = document.createElement('div'); live.id='dx-live';
    live.setAttribute('role','status'); live.setAttribute('aria-live','polite'); live.setAttribute('aria-atomic','true');
    live.style.cssText='position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0 0 0 0);clip-path:inset(50%);white-space:nowrap;border:0';
    document.body.appendChild(live);
  }
  var lastMsg='';
  function a11y(){
    document.querySelectorAll('.dx-pop.is-open').forEach(function(pop){
      // group headings are labels, not options — a listbox must not expose them as children
      pop.querySelectorAll('.dx-grp, .dx-divider').forEach(function(g){
        if(g.getAttribute('role')!=='presentation') g.setAttribute('role','presentation');
      });
      // in a grouped list the state only appears in the heading, so name each option in full
      if (pop.id==='dx2'){
        // the state name element also carries the two-letter abbreviation span, and reading the
        // whole element gives "AlabamaAL" — take only its own text node
        var ownText = function(el){
          if(!el) return '';
          var s='', n=el.firstChild;
          while(n){ if(n.nodeType===3) s+=n.textContent; n=n.nextSibling; }
          return s.trim() || el.textContent.trim();
        };
        var host = pop.querySelector('.dx-list') || pop, kid = host.firstElementChild, grp = '';
        while (kid){
          var cl = kid.className || '';
          if (/dx-grp/.test(cl)) { grp = ownText(kid); }
          else if (/dx-opt/.test(cl)) {
            var t = kid.querySelector('.dx-opt__txt');
            if (t){
              var st = kid.querySelector('.dx-opt__st');
              var state = st ? ownText(st) : grp;
              var want = t.textContent.trim() + (state ? (', ' + state) : '');
              if (kid.getAttribute('aria-label') !== want) kid.setAttribute('aria-label', want);
            }
          }
          kid = kid.nextElementSibling;
        }
      }
    });
    var open = document.querySelector('.dx-pop.is-open');
    if(!open){ lastMsg=''; return; }
    var box = open.querySelector('.dx-search input');
    if(!box || !box.value.trim()){ lastMsg=''; return; }
    var n = open.querySelectorAll('.dx-opt').length;
    var msg = n===0 ? ('No matches for ' + box.value.trim())
                    : (n + (n===1 ? ' match' : ' matches') + ' for ' + box.value.trim());
    if (msg !== lastMsg){ lastMsg = msg; live.textContent = msg; }
  }
  var inner = window.__dxPatch;
  window.__dxPatch = function(){ inner(); try { a11y(); } catch(err){} };
})();
(function(){
  if (window.__dxKB) return; window.__dxKB = 1;
  var mode='mouse', lx=null, ly=null;
  function ptr(e){ if(e.clientX===lx && e.clientY===ly) return; lx=e.clientX; ly=e.clientY; mode='mouse'; }
  ['mousemove','mouseenter','mouseover','pointermove'].forEach(function(t){ document.addEventListener(t, ptr, true); });
  document.addEventListener('mouseenter', function(e){
    if (mode==='keyboard' && e.target && e.target.classList && e.target.classList.contains('dx-opt')) e.stopPropagation();
  }, true);

  function openPop(){ return document.querySelector('.dx-pop.is-open'); }
  function boxOf(p){ return p.querySelector('.dx-search input'); }
  function trigger(p){ return document.querySelector('.dx-btn[aria-controls="'+p.id+'"]'); }
  function rowsOf(p){ return Array.prototype.slice.call(p.querySelectorAll('.dx-opt')); }
  function idxOf(rows){
    var i;
    for(i=0;i<rows.length;i++) if(rows[i].classList.contains('is-cursor')) return i;
    for(i=0;i<rows.length;i++) if(rows[i].classList.contains('is-sel'))    return i;
    return -1;
  }
  function setCur(p, rows, i){
    window.__dxKbd = 1;   /* only the keyboard calls this */
    if(i<0) i=0; if(i>rows.length-1) i=rows.length-1;
    for(var j=0;j<rows.length;j++) rows[j].classList.toggle('is-cursor', j===i);
    /* ── THE CURSOR MUST HOLD THE LINK, NOT JUST PAINT IT ──────────────────
       Panels WITH a search box (State, Area code) move real focus onto the
       row, which is why the browser shows the destination and prefetches it
       there. The box-less panels — Pattern, Digit, Tier — are driven by this
       function instead, and it only painted `.is-cursor`: measured on the
       homepage finder, every row in dx3/dx4/dx5 is an <a> with a real href
       (6/6, 11/11, 5/5) yet focus stayed on BUTTON.dx-btn, so arrowing them
       showed no URL and loaded nothing in the background. Give the row the
       same focus the boxed panels give it. Only when it is a real link, and
       never for a boxed panel — those already handle focus in move(). */
    if (!boxOf(p)) {
      var row = rows[i];
      if (row && row.tagName === 'A' && row.getAttribute('href')) {
        try { row.focus({ preventScroll: true }); } catch (e) {}
        /* PREFETCH only, same guarantee as everywhere else: a destination
           arrowed past but never opened fires no pixel or ad events. */
        try { if (window.__dxPreloadFn) window.__dxPreloadFn(row.getAttribute('href')); } catch (e2) {}
      }
    }
    var host = boxOf(p) || trigger(p);
    if (host && rows[i] && rows[i].id) host.setAttribute('aria-activedescendant', rows[i].id);
    try{ window.__dxReveal(p); }catch(e){}
  }

  // native selects jump to an option when you type a letter; without a search box this had nothing
  var buf='', bufAt=0, lastPop=null;
  function rowText(r){
    var n=r.querySelector('.dx-tiername')||r.querySelector('.dx-opt__txt')||r;
    return (n.textContent||'').trim().toLowerCase();
  }
  function seek(p, needle, fromNext){
    var rows=rowsOf(p); if(!rows.length) return false;
    var start=idxOf(rows), n=rows.length, from = fromNext ? start+1 : 0, i, r;
    for(i=0;i<n;i++){ r=rows[(from+i+n)%n]; if(rowText(r).indexOf(needle)===0){ setCur(p,rows,rows.indexOf(r)); return true; } }
    return false;
  }
  function typeAhead(p, ch){
    var now = performance.now();
    if (p !== lastPop || now - bufAt > 800) buf = '';   // a new panel, or a pause, starts a new word
    lastPop = p; bufAt = now;
    buf += ch;
    var allSame = buf.split('').every(function(c){ return c === buf.charAt(0); });
    if (seek(p, allSame ? buf.charAt(0) : buf, allSame)) return true;
    if (buf.length > 1){ buf = ch; return seek(p, ch, true); }   // the run matched nothing: restart from this key
    return false;
  }

  document.addEventListener('keydown', function(e){
    var p = openPop(); if(!p) return;
    var k = e.key, box = boxOf(p);
    var typing = box && e.target===box && box.value;
    if ((k==='ArrowLeft'||k==='ArrowRight') && typing) return;
    if (k==='ArrowLeft')  k='ArrowUp';
    if (k==='ArrowRight') k='ArrowDown';
    var nav = (k==='ArrowUp'||k==='ArrowDown'||k==='Home'||k==='End'||k==='PageUp'||k==='PageDown');
    if (nav) mode='keyboard';

    if (box) {
      if (e.key!==k) {
        e.preventDefault(); e.stopPropagation();
        box.dispatchEvent(new KeyboardEvent('keydown',{key:k,bubbles:true,cancelable:true}));
      }
      if (nav) requestAnimationFrame(function(){ try{ window.__dxReveal(p); }catch(err){} });
      return;
    }

    var rows = rowsOf(p); if(!rows.length) return;
    var i = idxOf(rows);
    if (k==='ArrowDown'){ e.preventDefault(); setCur(p, rows, i<0?0:i+1); }
    else if (k==='ArrowUp'){ e.preventDefault(); setCur(p, rows, i<0?rows.length-1:i-1); }
    else if (k==='Home'||k==='PageUp'){ e.preventDefault(); setCur(p, rows, 0); }
    else if (k==='End'||k==='PageDown'){ e.preventDefault(); setCur(p, rows, rows.length-1); }
    else if (k==='Enter' || k===' ' || k==='Spacebar'){
      if (i>=0){ e.preventDefault(); e.stopPropagation(); rows[i].click(); }
    }
    else if (k==='Escape'){
      e.preventDefault(); e.stopPropagation();
      var b = trigger(p); if(b){ b.removeAttribute('aria-activedescendant'); b.click(); b.focus({ preventScroll: true }); }
    }
    else if (k.length===1 && !e.ctrlKey && !e.metaKey && !e.altKey && /\S/.test(k)){
      mode='keyboard';
      if (typeAhead(p, k.toLowerCase())) { e.preventDefault(); e.stopPropagation(); }
    }
  }, true);
})();
(function(){
  function wire(){
    ['dx1','dx2','dx3','dx4','dx5'].forEach(function(id){
      var p=document.getElementById(id); if(!p||p.__dxObs) return; p.__dxObs=1;
      var busy=false;
      var obs=new MutationObserver(function(){
        if(busy) return; busy=true; obs.disconnect();
        try{ window.__dxPatch(); }catch(e){}
        obs.observe(p,{childList:true,subtree:true}); busy=false;
      });
      obs.observe(p,{childList:true,subtree:true});
    });
    try{ window.__dxPatch(); }catch(e){}
  }
  document.addEventListener('click', function(){ setTimeout(wire,0); }, true);
  setTimeout(wire, 0); setTimeout(wire, 400);
})();
/*__DXMEASURE__*/(function(){
  var s = document.getElementById('dxMeasure') || document.createElement('style');
  s.id = 'dxMeasure';
  s.textContent = ".dx-pop.dx-measuring .dx-list{width:max-content !important;overflow:visible !important}"
    + ".dx-pop.dx-measuring .dx-opt{width:max-content !important;max-width:none !important;overflow:visible !important}"
    + ".dx-pop.dx-measuring .dx-opt > *{overflow:visible !important;text-overflow:clip !important;"
    + "min-width:0 !important;max-width:none !important;flex:0 0 auto !important;white-space:nowrap !important}"
    + ".dx-pop.dx-measuring .dx-grp,.dx-pop.dx-measuring .dx-more,.dx-pop.dx-measuring .dx-none{width:max-content !important}";
  document.head.appendChild(s);
})();
/*__DXFIT__*/(function(){var s=document.getElementById('dxFit')||document.createElement('style');s.id='dxFit';s.textContent=".de-heroX__finder-stack{max-width:100% !important}.de-heroX__finder-stack > *,.de-finder__col,.de-finder__wrap,.dx-wrap{min-width:0 !important;max-width:100% !important}.dx-btn{min-width:0 !important;max-width:100% !important;white-space:nowrap !important;overflow:hidden !important;text-overflow:ellipsis !important}@media (max-width:399.98px){.de-heroX__finder-stack .de-finder__col .dx-btn.dx-btn{font-size:15px !important}}@media (max-width:359.98px){.de-heroX__finder-stack .de-finder__col .de-finder__wrap.de-finder__wrap.de-finder__wrap::after{width:22px !important;height:22px !important;left:4px !important}.de-heroX__finder-stack .de-finder__col .de-finder__wrap.de-finder__wrap.de-finder__wrap .de-finder__icon{left:7px !important;width:14px !important;height:14px !important}.de-heroX__finder-stack .de-finder__col .dx-btn.dx-btn{padding-left:28px !important;padding-right:20px !important;font-size:14px !important;background-position:calc(100% - 8px) 50% !important}}@media (max-width:299.98px){.de-heroX__finder-stack .de-finder__col .de-finder__wrap.de-finder__wrap.de-finder__wrap::after{display:none !important}.de-heroX__finder-stack .de-finder__col .de-finder__wrap.de-finder__wrap.de-finder__wrap .de-finder__icon{display:none !important}.de-heroX__finder-stack .de-finder__col .dx-btn.dx-btn{padding-left:12px !important;padding-right:18px !important;font-size:14px !important;background-position:calc(100% - 6px) 50% !important}}";document.head.appendChild(s);})();
/*__DXFITP__*/(function(){var s=document.getElementById('dxFitPresets')||document.createElement('style');s.id='dxFitPresets';s.textContent=".de-heroX__presets{min-width:0 !important;max-width:100% !important}.de-heroX__presets > *,.de-heroX__preset,.de-heroX__preset > *{min-width:0 !important;max-width:100% !important}@media (max-width:349.98px) and (min-width:300px){.de-heroX__preset .de-heroX__preset-ic{width:26px !important;height:26px !important;flex:0 0 26px !important}.de-heroX__preset .de-heroX__preset-ic svg{width:15px !important;height:15px !important}.de-heroX__preset{gap:6px !important;padding-left:8px !important;padding-right:8px !important}}@media (max-width:299.98px){.de-heroX__preset .de-heroX__preset-ic{display:none !important}.de-heroX__preset{padding-left:10px !important;padding-right:10px !important;gap:0 !important}}";document.head.appendChild(s);})();
/*__DXGAP__*/(function(){
    var SPEC = [ ['.de-recent','margin-bottom',0.25,6],
                 ['.de-featuredZ','padding-bottom',0.30,8],
                 ['.de-why','padding-top',0.45,14] ];
    function camel(p){ return p.replace(/-([a-z])/g,function(_,c){return c.toUpperCase();}); }
    function apply(){
      SPEC.forEach(function(s){
        document.querySelectorAll(s[0]).forEach(function(el){
          el.style.removeProperty(s[1]);
          var nat = parseFloat(getComputedStyle(el)[camel(s[1])]) || 0;
          if (!nat) return;
          el.style.setProperty(s[1], Math.max(s[3], Math.round(nat*s[2]))+'px','important');
        });
      });
    }
    apply();
    var t; addEventListener('resize', function(){ clearTimeout(t); t=setTimeout(apply,150); });
    window.__dxGapApply = apply;
  })();

} catch(e){ if(window.console) console.warn('dx layer', e); }
    try {
window.__dxSheet = function(){
  var v = (location.search.match(/[?&]sheet=([abcdefg])/)||[])[1] || 'g';
  var st = document.getElementById('dxSheet') || document.createElement('style');
  st.id='dxSheet'; document.head.appendChild(st);
  var MQ = '@media (max-width:640px),(max-height:560px){';
  var base = MQ + '.dx-pop{padding:6px !important}' + '}';
  var A = MQ + '.dx-pop{max-height:var(--dx-sheet-max,72vh) !important}' + '}';
  var B = MQ + '.dx-pop{bottom:auto !important;transform:translate(-50%,-50%) !important;'
             + 'max-height:var(--dx-sheet-max,70vh) !important;border-radius:18px !important;'
             + 'box-shadow:0 18px 60px rgba(0,0,0,.30) !important}' + '}';
  var C = MQ + '#dx1.is-open,#dx2.is-open{max-height:none !important}'
             + '#dx3,#dx4,#dx5{max-height:var(--dx-sheet-max,80vh) !important}' + '}';
  var D = MQ + '.dx-pop{max-height:var(--dx-sheet-max,72vh) !important}'
             + '.dx-pop.dx-2col .dx-list{display:grid !important;grid-template-columns:1fr 1fr !important;'
             + 'column-gap:6px !important;align-content:start !important}'
             + '.dx-pop.dx-2col .dx-list>.dx-opt:first-child{grid-column:1/-1 !important}'
             + '.dx-pop.dx-2col .dx-list>.dx-divider{grid-column:1/-1 !important}' + '}';
  var E = MQ + '.dx-pop{border-radius:12px !important;padding:4px !important;'
             + 'box-shadow:0 12px 34px rgba(0,0,0,.18),0 2px 8px rgba(0,0,0,.08) !important}'
             + '.dx-backdrop{opacity:0 !important;pointer-events:none !important}'
             + '.dx-opt{min-height:40px !important;padding:8px 11px !important;font-size:14.5px !important}'
             + '.dx-opt--tier{min-height:44px !important}'
             + '.dx-search input{height:38px !important;font-size:16px !important}' + '}';
  var F = MQ + '.dx-pop{border:1px solid #e4e9f3 !important;border-radius:14px !important;padding:5px !important;'
             + 'box-shadow:0 10px 30px rgba(16,26,54,.12),0 2px 6px rgba(16,26,54,.06) !important}'
             + '.dx-backdrop{opacity:0 !important;pointer-events:none !important}'
             + '.dx-opt{min-height:40px !important;padding:8px 11px !important;font-size:14.5px !important}'
             + '.dx-opt--tier{min-height:44px !important}'
             + '.dx-search input{height:38px !important;font-size:16px !important}'
             + '.dx-open-host{border-color:#0071e3 !important;box-shadow:0 0 0 3px rgba(0,113,227,.14) !important}' + '}';
  var G = MQ + '.dx-pop{border:1px solid rgba(16,26,54,.10) !important;border-radius:13px !important;padding:4px !important;'
             + 'box-shadow:0 14px 36px rgba(16,26,54,.16),0 3px 9px rgba(16,26,54,.09) !important}'
             + '.dx-backdrop{opacity:0 !important;pointer-events:none !important}'
             + '.dx-pop .dx-opt{min-height:32px !important;padding:4px 11px !important;'
             + 'font-size:14px !important;line-height:1.25 !important}'
             + '.dx-pop .dx-opt--tier{min-height:38px !important;padding:6px 9px 6px 3px !important}'
             + '#dx3 .dx-opt{min-height:38px !important}'
             + '.dx-pop .dx-search{padding:3px !important;margin:-4px -4px 2px !important}'
             + '.dx-pop .dx-search input{height:32px !important;font-size:16px !important}'
             + '#dx1 .dx-opt__ab,#dx2 .dx-ab2{font-size:11.5px !important}'
             + '.dx-pop .dx-grp{padding:6px 11px 2px !important;font-size:10px !important}'
             + '.dx-pop .dx-divider{margin:2px 0 !important}'
             + '#dx3 .dx-pat-meta{font-size:11.5px !important;margin-top:0 !important}'
             + '.dx-open-host{border-color:#0071e3 !important;box-shadow:0 0 0 3px rgba(0,113,227,.16) !important}' + '}';
  st.textContent = base + (v==='b'?B : v==='c'?C : v==='d'?D : v==='e'?E : v==='f'?F : v==='g'?G : A);

  // measure the home-indicator inset once; desktop Chrome reports 0, a real iPhone ~34px
  var probe = document.createElement('div');
  probe.style.cssText='position:fixed;left:-9999px;bottom:env(safe-area-inset-bottom,0px);height:1px';
  document.body.appendChild(probe);
  var safeB = parseFloat(getComputedStyle(probe).bottom) || 0;
  probe.style.bottom='env(safe-area-inset-top,0px)';
  var safeT = parseFloat(getComputedStyle(probe).bottom) || 0;
  probe.remove();

  function fit(){
    var narrow = matchMedia('(max-width:640px),(max-height:560px)').matches;
    if(!narrow) return;
    var vv = window.visualViewport;
    var h  = vv ? vv.height : innerHeight;      // excludes the iOS toolbar; vh does not
    var off= vv ? vv.offsetTop : 0;
    var root = document.documentElement;
    var cap = v==='b' ? Math.min(Math.round(h*0.70), 540)
            : v==='c' ? Math.min(Math.round(h*0.80), 640)
            :           Math.min(Math.round(h*0.72), 560);
    root.style.setProperty('--dx-sheet-max', cap+'px');
    // a list of short, uniform items wastes a whole screen in one column — pair them up.
    // Only for lists with no search box (a long searchable list is easier to scan in one column).
    if (v==='d'){
      document.querySelectorAll('.dx-pop').forEach(function(p){
        var rows = p.querySelectorAll('.dx-opt');
        var hasBox = !!p.querySelector('.dx-search input');
        var isCards = !!p.querySelector('.dx-opt--tier');
        var longest = 0;
        rows.forEach(function(r){ var t=r.querySelector('.dx-opt__txt'); if(t) longest=Math.max(longest, t.textContent.trim().length); });
        var two = !hasBox && !isCards && rows.length>=7 && longest<=20;
        p.classList.toggle('dx-2col', two && narrow);
      });
    }
    if (v==='f'){
      document.querySelectorAll('.dx-btn').forEach(function(b){
        var host = b.closest('.de-finder__wrap') || b;
        var pp = document.getElementById(b.getAttribute('aria-controls'));
        if(!pp || !pp.classList.contains('is-open')) host.classList.remove('dx-open-host');
      });
      document.querySelectorAll('.dx-pop.is-open').forEach(function(p){
        var b = document.querySelector('.dx-btn[aria-controls="'+p.id+'"]'); if(!b) return;
        var r = b.getBoundingClientRect();
        if (r.bottom < off || r.top > off + h) return;
        (b.closest('.de-finder__wrap') || b).classList.add('dx-open-host');
        var card = b.closest('.de-heroX__finder');
        var left, wI;
        if (card){
          var cr = card.getBoundingClientRect(), ccs = getComputedStyle(card);
          var pl = parseFloat(ccs.paddingLeft)||0, prr = parseFloat(ccs.paddingRight)||0;
          left = cr.left + pl; wI = cr.width - pl - prr;
        } else { left = 8; wI = innerWidth - 16; }
        var below = (off + h) - r.bottom - 8 - safeB;
        var above = r.top - off - 8 - safeT;
        var down  = below >= 220 || below >= above;
        var maxH  = Math.max(160, Math.min(Math.round(down?below:above), Math.round(h*0.62), 420));
        p.style.setProperty('left', Math.round(left)+'px','important');
        p.style.setProperty('right','auto','important');
        p.style.setProperty('transform','none','important');
        p.style.setProperty('width', Math.round(wI)+'px','important');
        p.style.setProperty('min-width','0','important');
        p.style.setProperty('max-width','none','important');
        p.style.setProperty('max-height', maxH+'px','important');
        if (down){ p.style.setProperty('top',(r.bottom+8)+'px','important'); p.style.setProperty('bottom','auto','important'); }
        else     { p.style.setProperty('bottom',(innerHeight-r.top+8)+'px','important'); p.style.setProperty('top','auto','important'); }
      });
      return;
    }
    if (v==='e'){
      document.querySelectorAll('.dx-pop.is-open').forEach(function(p){
        var b = document.querySelector('.dx-btn[aria-controls="'+p.id+'"]'); if(!b) return;
        var r = b.getBoundingClientRect();
        // if the control has scrolled out of view there is nothing to anchor to —
        // leave it to the component, which closes the panel in that case
        if (r.bottom < off || r.top > off + h) return;
        var hasBox = !!p.querySelector('.dx-search input');
        var maxW = Math.min(430, innerWidth - 16);
        var w = Math.min(maxW, Math.max(r.width, hasBox ? 340 : 260));
        var pad = 8;
        var below = (off + h) - r.bottom - pad - safeB;
        var above = r.top - off - pad - safeT;
        var down  = below >= 240 || below >= above;
        var room  = down ? below : above;
        var maxH  = Math.max(160, Math.min(Math.round(room), Math.round(h*0.70), 460));
        p.style.setProperty('left', Math.max(8, Math.min(r.left, innerWidth - w - 8))+'px','important');
        p.style.setProperty('right','auto','important');
        p.style.setProperty('transform','none','important');
        p.style.setProperty('width', w+'px','important');
        p.style.setProperty('min-width','0','important');
        p.style.setProperty('max-width', maxW+'px','important');
        p.style.setProperty('max-height', maxH+'px','important');
        if (down){ p.style.setProperty('top', (r.bottom+6)+'px','important'); p.style.setProperty('bottom','auto','important'); }
        else     { p.style.setProperty('bottom', (innerHeight - r.top + 6)+'px','important'); p.style.setProperty('top','auto','important'); }
      });
      return;
    }
    var lift = Math.max(0, innerHeight - h - off);
    var topGap = Math.round(off + Math.max(64, h*0.09) + safeT);
    document.querySelectorAll('.dx-pop.is-open').forEach(function(p){
      if (v==='b'){
        p.style.setProperty('bottom','auto','important');
        p.style.setProperty('top', Math.round(off + h/2)+'px','important');
        p.style.setProperty('transform','translate(-50%,-50%)','important');
      } else {
        // the component lifts with inline !important but knows nothing about the home indicator
        p.style.setProperty('bottom', (lift + 8 + safeB)+'px','important');
        if (v==='c' && (p.id==='dx1'||p.id==='dx2')){
          p.style.setProperty('top', topGap+'px','important');
          p.style.setProperty('max-height','none','important');
        }
      }
    });
  }
  fit();
  var rafQ = false;
  function fitSoon(){ if(rafQ) return; rafQ = true;
    requestAnimationFrame(function(){ rafQ = false; try{ fit(); }catch(e){} }); }
  if (window.visualViewport){ visualViewport.addEventListener('resize', fitSoon); visualViewport.addEventListener('scroll', fitSoon); }
  window.addEventListener('resize', fitSoon);
  window.addEventListener('scroll', fitSoon, true);   // must land after the component's place()
  document.addEventListener('click', function(){ setTimeout(fit,0); }, true);
  var inner = window.__dxPatch;
  if (inner && !inner.__sheetWrapped){
    var w = function(){ inner(); try{ fit(); }catch(e){} };
    w.__sheetWrapped = 1; window.__dxPatch = w;
  }
  return { variant:v, safeBottom:safeB, safeTop:safeT };
};
(function(){
  /* "District of Columbia" is long enough that its abbreviation wrapped onto a
     second line, giving that one row a 48px height next to 32px neighbours.
     Keep the row on one line and let the NAME ellipsise if it ever has to —
     the abbreviation on the right must never move. */
  var s=document.getElementById('dxRow')||document.createElement('style');
  s.id='dxRow';
  s.textContent="/* Only the UA underline needs neutralising. A site-wide `a` rule (#0077ed) outranks .dx-opt, so the row colour has to be restated for anchors — but ONLY colour. Two mistakes already made here: colour:inherit !important killed the white hover text (black text on the blue pill, abbreviation white), and background-color:transparent !important killed the blue pill itself, because !important beats the sheet's non-important background whatever the specificity. Anchors have no background of their own, so never touch background here. The site also puts `transition: color .15s` on every <a>, which made the row text FADE from dark to white on hover instead of switching instantly the way the plain <div> rows always did — transition:none restores that. */a.dx-opt{text-decoration:none !important;color:#1d1d1f !important;transition:none !important}.dx-opt:focus,.dx-opt:focus-visible{outline:none !important;box-shadow:none !important}a.dx-opt.is-cursor{color:#fff !important}a.dx-opt.dx-opt--tier.is-cursor{color:#1d1d1f !important}\n#dx1 .dx-opt{flex-wrap:nowrap !important}"
    +"#dx1 .dx-opt__txt{min-width:0 !important;overflow:hidden !important;text-overflow:ellipsis !important;white-space:nowrap !important}"
    +"#dx1 .dx-opt__ab{flex:0 0 auto !important;margin-left:auto !important;padding-left:16px !important;white-space:nowrap !important}"+".de-finder__wrap .dx-opt__tick,.dx-wrap .dx-opt__tick,.dx-btn .dx-opt__tick{display:none !important}"+".dx-sr{position:absolute !important;width:1px !important;height:1px !important;overflow:hidden !important;clip:rect(0 0 0 0) !important;clip-path:inset(50%) !important;white-space:nowrap !important;border:0 !important;padding:0 !important;margin:-1px !important}"+".de-finder__wrap::before,.dx-wrap::before,.dx-wrap::after,.dx-btn::before,.dx-btn::after{content:none !important;display:none !important}";
  document.head.appendChild(s);
})();
 if (window.__dxSheet) window.__dxSheet();
} catch(e){ if(window.console) console.warn('dx sheet', e); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
